if (typeof userDetailsRemoved === 'undefined') {
    function userDetailsRemoved() {
        if (typeof SalesToolkit !== 'undefined' && SalesToolkit.Forms && typeof SalesToolkit.Forms.userDetails !== 'object' && SalesToolkit.Theme && SalesToolkit.Theme.getBooleanProperty('showCartCameraIcon', false)) {
            $('#salestoolkit-camera').show();
        } else {
            $('#salestoolkit-camera').hide();
        }
    }
}

const cartModule = (function () {

    const _templateHTML = `
    <!-- BEGIN CART CONTAINER -->
    <div id="cartWrapper" class="page-container">
        <!-- BEGIN SIDEBAR -->
        <div class="page-sidebar-wrapper">
            <div id="mySidebar" class="page-sidebar navbar-collapse collapse">
                <!-- BEGIN SIDEBAR MENU -->
                <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu " data-keep-expanded="false"
                    data-auto-scroll="true" data-slide-speed="200">
                    <li class="customcolor">
                        <a href="javascript:;" data-module-action="loadIndex">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon home-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="homeButton"
                                    data-translation-default="Home">Home</span>
                            </div>
                        </a>
                    </li>
                    <li class=" customcolor">
                        <a href="assetLibrary.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="Library" class="side-bar-icon library-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="libraryButton"
                                    data-translation-default="Library">Library</span>
                            </div>
                        </a>
                    </li>
                    <li id="favouritesSideMenuIcon" class="customcolor">
                        <a href="javascript:;" data-module-action="loadFavourites">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon favourites-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="favouritesButton"
                                    data-translation-default="Favourites">Favourites</span>
                            </div>
                        </a>
                    </li>
                    <li id="inboxSideMenuIcon" style="display:none" class="customcolor">
                        <a href="inbox.html">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon inbox-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-inbox-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="inboxButton"
                                    data-translation-default="Inbox">Inbox</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>
                    <li id="cartSideMenuIcon" class="active open customcolor">
                        <a href="javascript:;" data-module-action="loadCart">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon cart-icon" style="width: 36px;">
                                        <span class="badge badge-warning" id="salestoolkit-cart-badge"></span>
                                    </div>
                                </div>
                                <span class="title" data-translation-key="cartButton"
                                    data-translation-default="Cart">Cart</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>
                    <li id="meetingsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showMeetingsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon meetings-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="meetingsButton"
                                    data-translation-default="Meetings">Meetings</span>
                            </div>
                        </a>
                    </li>
                    <li id="contactsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showContactsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon contacts-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="contactsButton"
                                    data-translation-default="Contacts">Contacts</span>
                            </div>
                        </a>
                    </li>
                    <li class="demoComparatorSideMenu customcolor">
                        <a id="comparator-side-menu" href="javascript:;" onclick="loadPlugin('debugComparator', this, false)">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon plugin-icon"
                                            src="img/default/comparator_menu.svg" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="pluginButton"
                                    data-translation-default="Debug Comparator">Debug Comparator</span>
                            </div>
                            <span class="selected"></span>
                        </a>
                    </li>
                    <li id="adminSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showAdminScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon admin-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="adminButton"
                                    data-translation-default="Admin">Admin</span>
                            </div>
                        </a>
                    </li>
                   <li id="faqsSideMenuIcon" class="customcolor">
                        <a href="javascript:;" onclick="showFaqsScreen()">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon faqs-icon" style="width: 36px;">
                                    </div>
                                </div>
                                <span class="title" data-translation-key="faqButton"
                                    data-translation-default="FAQs">FAQs</span>
                            </div>
                        </a>
                    </li>
                    <li id="newsSideMenuIcon" class="customcolor">
                        <a onclick="loadNews(this); return false;">
                            <div class="sidemenu-tile-contents">
                                <div class="sidemenu-icon-wrapper-outer">
                                    <div class="sidemenu-icon-wrapper-inner">
                                        <img alt="" class="side-bar-icon news-icon" style="width: 36px;" />
                                    </div>
                                </div>
                                <span class="title" data-translation-key="newsButton"
                                    data-translation-default="News">News</span>
                            </div>
                        </a>
                    </li>
                </ul>
                <!-- END SIDEBAR MENU -->
                <script src="js/sidemenufix.js?version=b18305"></script>
            </div>
        </div>
        <!-- END SIDEBAR -->
        <!-- BEGIN CONTENT -->
        <div class="page-content-wrapper">
            <div id="main-div-center" class="page-content">
                <!-- BEGIN SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <div class="modal fade send-cart" id="basic" tabindex="-1" role="basic" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                                <h4 class="modal-title">
                                    <i class="icon-envelope font-blue"></i>
                                    <span id="sendTitle" data-translation-key="sendAssets" data-translation-default="Send Assets">Send
                                        Assets</span>
                                </h4>
                            </div>
                            <div class="portlet-body form">
                                <form data-multiple-contacts-possible="true" role="form">
                                    <div id="form-body" class="form-body">
                                        <span id="contactEmailHint" class="sendpadding"
                                            style="display: block;margin-bottom: 5px; display:none;"
                                            data-translation-key="contactEmailHint"
                                            data-translation-default="Tap the email icon to the left to select contact from device or here to type manually."></span>
                                        <label id="emailAddressesLabel" class="sendpadding">
                                            <span data-translation-key="emailAddress"
                                                data-translation-default="E-Mail Address">E-mail Address</span><span
                                                id="salestoolkit-email-plural">es</span>
                                        </label>
                                        <div class="form-group formgrouppadding" id="salestoolkit-email-addresses-div"
                                            style="margin-top: -10px;"></div>
                                        <div class="form-group formgrouppadding" id="salestoolkit-form-fields-div"
                                            style="margin-top: -10px;">
                                        </div>
                                        <div class="checkbox-list tccheck accepttc">
                                            <div class="pull-left" style="margin-top: -30px;">
                                                <label class="pull-left">
                                                    <div class="checker">
                                                        <span class="">
                                                            <input id="salestoolkit-me-too-checkbox" type="checkbox"
                                                                onchange="this.parentNode.className = this.checked ? 'checked' : '';" />
                                                        </span>
                                                    </div>
                                                    <span class="hasTranslationKey" data-translation-key="sendMeCopy"
                                                        data-translation-default="Send me a copy as well">Send me a copy
                                                        as well</span>
                                                </label>
                                            </div>
                                            <div style="display:none; width:94.9%; padding-bottom:30px;" class="shareSavedCartName">
                                                <label style="float: left;" for="shareSavedCartName"
                                                data-translation-key="cartName"
                                                data-translation-default="Cart Name">Cart Name</label>
                                                <input class="form-control" id="cartSaveName" name="cartSaveName" maxlength="45" type="text" />
                                            </div>
                                            <div id="salestoolkit-cart-save-share-error"
                                                class="alert alert-danger display-hide">
                                                <button type="button" class="close" data-close="alert"></button>
                                                <span id="cart-save-share-error-message"></span>
                                            </div>
                                            <div style="display:none; width:94.9%; padding-bottom:30px;" class="shareSavedCartNote">
                                                <label style="float: left;" for="shareSavedCartNote"
                                                data-translation-key="note"
                                                data-translation-default="Note">Note</label>
                                                <textarea id="shareSavedCartNote" onkeyup="setHeight('shareSavedCartNote');" maxlength="1024" class="form-control" type="text" style="margin-bottom: 10px; max-width: 100%; min-width: 100%;" ></textarea>
                                            </div>
                                            <div class="sendcartEmailcustom" style="margin-bottom:18px; text-align: left;">
                                                <label >
                                                    <a href="javascript:;" style="margin-left: 5px;"
                                                        onclick="this.style.display='none'; document.getElementById('salestoolkit-email-customization').style.display=''; document.getElementById('salestoolkit-custom-email-enabled').checked='checked'; document.getElementById('salestoolkit-custom-email-enabled').parentNode.className='checked';">
                                                        <span data-translation-key="clickCustomiseAppearance"
                                                            data-translation-default="Click to Customise Email Appearance">Click
                                                            to Customise Email Appearance</span>
                                                    </a>
                                                </label>
                                            </div>
                                            <div id="salestoolkit-email-customization" style="display: none;">
                                                <div class="form-group" style="overflow: hidden; clear: left;">
                                                    <label class="pull-left">
                                                        <div class="checker">
                                                            <span class="">
                                                                <input id="salestoolkit-custom-email-enabled"
                                                                    type="checkbox"
                                                                    onchange="this.parentNode.className = this.checked ? 'checked' : ''; document.getElementById('salestoolkit-custom-email-fields').style.display = this.checked ? '' : 'none';" />
                                                            </span>
                                                        </div>
                                                        <span data-translation-key="customAppearance"
                                                            data-translation-default="Custom Email Appearance">Custom
                                                            Email Appearance</span>
                                                    </label>
                                                </div>
                                                <div class="form-group" id="salestoolkit-custom-email-fields">
                                                    <label style="float: left;" for="salestoolkit-custom-email-subject"
                                                        data-translation-key="subject"
                                                        data-translation-default="Subject">Subject</label>
                                                    <input id="salestoolkit-custom-email-subject" type="text"
                                                        placeholder="No Subject" data-translation-target="placeholder"
                                                        data-translation-key="noSubject"
                                                        data-translation-default="No Subject" class="form-control"
                                                        style="margin-bottom: 10px; max-width: 100%; min-width: 100%;" />
                                                    <label style="float: left; text-align:left;" for="salestoolkit-custom-email-body"
                                                        data-translation-key="body"
                                                        data-translation-default="Body">Body</label>
                                                    <textarea id="salestoolkit-custom-email-body" placeholder="No Body"
                                                        data-translation-target="placeholder"
                                                        data-translation-key="noBody" data-translation-default="No Body"
                                                        class="form-control"
                                                        style="margin-bottom: 18px; min-height: 100px; max-width: 100%; min-width: 100%;"></textarea>
                                                </div>
                                            </div>
                                            <button style="margin-top: 5px;" type="button" onclick="clearFormFields()"
                                                class="btn default sendcartEmailcustomButtons" data-dismiss="modal">
                                                <span data-translation-key="cancelButton"
                                                    data-translation-default="Cancel">Cancel</span>
                                            </button>
                                            <button style="margin-top: 5px;" id="salestoolkit-do-share" type="button"
                                                class="btn blue sendcartEmailcustomButtons" data-dismiss="modal">
                                                <span data-translation-key="send"
                                                    data-translation-default="Send">Send</span>
                                            </button>
                                            <button style="margin-top: 5px;"
                                                id="salestoolkit-sharelink" type="button"
                                                class="btn blue sendcartEmailcustomButtons">
                                                <span data-translation-key="shareLink"
                                                    data-translation-default="Share Link">Share Link</span>
                                            </button>
                                        </div>
                                        <div id="salestoolkit-share-email-error-message"
                                            class="alert alert-danger display-hide">
                                            <button type="button" class="close" data-close="alert"></button>
                                            <span data-translation-key="shareNoEmailErrorMessage"
                                                data-translation-default="Unable to send: Please specify at least one recipient."></span>
                                        </div>
                                        <div id="salestoolkit-share-email-error-message-invalid"
                                            class="alert alert-danger display-hide">
                                            <button type="button" class="close" data-close="alert"></button>
                                            <span data-translation-key="shareInvalidErrorMessage"
                                                data-translation-default="Unable to send: Invalid email in the address list"></span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
                <!-- END SAMPLE PORTLET CONFIGURATION MODAL FORM-->
                <div class="row">
                    <div id="main-panel" class="col-md-12">
                        <div class="sidePadding10 portlet light">
                            <div class="portlet-title">
                                <div class="caption">
                                    <strong><span id="cartContentsTitle">Cart Contents</span></strong>
                                </div>
                                <div class="actions" style="display: flex;">
                                    <a style="display:none" href="javascript:;" onclick="openedCameraModal()" id="salestoolkit-camera"
                                        class="btn btn-sm" 
                                        data-original-title="Scan" 
                                        data-tooltip-translationkey="scan"
                                        data-tooltip-translation-default ="Scan">
                                        <img id="cart-camera-icon" style="display: inline;">
                                    </a>
                                    <a class="btn btn-sm" style="display:none; background:none !important;"
                                        id="salestoolkit-share-cart" data-toggle="modal" data-bs-toggle="modal" href="#basic" 
                                        data-original-title="Send Cart" 
                                        data-tooltip-translationkey="sendCart"
                                        data-tooltip-translation-default ="Send Cart">
                                        <img id="cart-send-icon" style="display: inline;">
                                    </a>
                                    <a class="btn btn-sm" style="display:none; background:none !important;"
                                        id="salestoolkit-registerInterest-cart" data-toggle="modal" data-bs-toggle="modal" href="#basic" 
                                        data-original-title="Register Interest" 
                                        data-tooltip-translationkey="registerInterest"
                                        data-tooltip-translation-default ="Register Interest">
                                        <img id="cart-registerInterest-icon" style="display: inline;">
                                    </a>
                                    <a class="btn btn-sm" style="display:none; background:none !important;"
                                        id="salestoolkit-mlr-cart" data-toggle="modal" data-bs-toggle="modal" href="#basic" 
                                        data-original-title="MLR Approval" 
                                        data-tooltip-translationkey="mlrApproval"
                                        data-tooltip-translation-default ="MLR Approval">
                                        <img id="cart-mlr-icon" style="display: inline;">
                                    </a>
                                    <a href="javascript:;" onclick="openedCartModal()" id="salestoolkit-empty-cart"
                                        data-toggle="modal" data-bs-toggle="modal" data-target="#cartModal" class="btn btn-sm" 
                                        data-original-title="Empty Cart" 
                                        data-tooltip-translationkey="emptyCart"
                                        data-tooltip-translation-default ="Empty Cart">
                                        <img id="cart-empty-icon" style="display: inline;">
                                    </a>
                                    <a href="javascript:;" id="salestoolkit-save-cart" onclick="openCartSaveModal()"
                                        class="btn btn-sm" 
                                        data-original-title="Save Cart" 
                                        data-tooltip-translationkey="saveCart"
                                        data-tooltip-translation-default ="Save Cart">
                                        <img id="save-cart-icon" style="display: inline;">
                                    </a>
                                    <div class="view-toggler">
                                        <img id="list-view-icon" 
                                        data-original-title="List View" 
                                        data-tooltip-translationkey="toggleViewList"
                                        data-tooltip-translation-default ="List View" >
                                        <img id="thumbnail-icon" 
                                        data-original-title="Thumb View" 
                                        data-tooltip-translationkey="toggleViewThumb"
                                        data-tooltip-translation-default ="Thumb View">
                                    </div>
                                    <a class="btn btn-circle btn-icon-only btn-default fullscreen" href="javascript:;">
                                        <img class="zoomin-icon"
                                        data-original-title="Full Screen"
                                        data-tooltip-translationkey="fullscreen"
                                        data-tooltip-translation-default="Full Screen">
                                        <img class="zoomout-icon"
                                        data-original-title="Minimise"
                                       data-tooltip-translationkey="minimise"
                                       data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div class="portlet-body">
                                <div id="breadcrumbsbuttonhide" class="breadcrumbsBackButton">
                                    <a type="button" onclick="goBack(); return false;">
                                        <img class="backButtonIcon" src="img/default/back_icon.svg" width="20px"
                                            height="20px">
                                        <span style="font-weight: 600; font-size: 14px; margin-left: 4px;"
                                            data-translation-key="back" data-translation-default="Back">Back</span>
                                    </a>
                                </div>
                                <div class="row" id="salestoolkit-cart-portlet">
                                </div>
                                <br>
                            </div>
                        </div>
                    </div>
                    <div id="saved-carts-panel" class="col-lg-3 col-md-3" style="display: none;">
                        <div class="portlet light">
                            <div class="portlet-title">
                                <div class="caption">
                                    <strong>
                                        <span class='hasTranslationKey' data-translation-key="savedCarts"
                                            data-translation-default="Saved Carts">Saved Carts</span>
                                    </strong>
                                </div>
                                <div class="actions" style="display:flex;">
                                    <a href="javascript:;" class="btn btn-circle btn-icon-only btn-default fullscreen">
                                        <img class="zoomin-icon" src="img/default/zoom_icon.svg"
                                            data-original-title="Full Screen" data-tooltip-translationkey="fullscreen"
                                            data-tooltip-translation-default="Full Screen">
                                        <img class="zoomout-icon" src="img/default/zoom_out_icon.svg"
                                            data-original-title="Minimise" data-tooltip-translationkey="minimise"
                                            data-tooltip-translation-default="Minimise">
                                    </a>
                                </div>
                            </div>
                            <div class="portlet-body" >
                               <div id="atheneum-saved-carts-view"></div>
                               <div id="saved-carts-paging" class="collectionBrowser-group-wrapper"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END PAGE CONTENT-->
        </div>
    </div>
    <div class="notific8-container top left" style="z-index: 1100; position: fixed;"></div>
    <!-- END  CART CONTAINER -->
    `;

    //#region Variables
    let salestoolkitUICartInstance = null;
    let FAVOURITES_HEART_FULL = '';
    let FAVOURITES_HEART_EMPTY = '';
    let REMOVE_ICON = '';
    let singleEmailMode = false;

    let cardReader = null;
    let html5QrCode = null;
    let hasSomeSharing = false;
    let _originalOnResize = null;

    let currentFilteredContactFilters = null;
    let currentContactFilters = null;

    let emailInputTimeout = undefined;
    let pageIndex = 0;
    let pageControls = null;
    let cartNameOverwrite = null;
    let overwriteData = null;
    let overwriteNote = null;
    let overwriteUseLink = false;
    let cartToDelete = null;

    let mainTimeoutId = null;
    let countdownStarterId = null; // ID for the timeout that starts the countdown
    let countdownIntervalId = null;
    let pollingIntervalId = null;
    let remoteCompletionWaiting = false;
    const activityEvents = ['mousemove', 'mousedown', 'touchstart', 'keydown'];

    //#endregion
    //#region PANELS 
    const savedCarts = $('#saved-carts-panel');
    const main = $('#main-panel');

    let savedCartsUltraLargeCols = 3; // Example: For extra large screens (e.g., Bootstrap col-xl-3)
    let savedCartsLargeCols = 4;    // Example: For large screens (e.g., Bootstrap col-lg-4)
    let savedCartsMediumCols = 6;   // Example: For medium screens (e.g., Bootstrap col-md-6)
    let savedCartsSmallCols = 12;   // Example: For small screens (e.g., Bootstrap col-sm-12)

    /**
     * Removes all Bootstrap-like 'col-' classes from a given jQuery element.
     * @param {jQuery} element - The jQuery object whose classes need to be cleaned.
     */
    function removeAllColCSS(element) {
        // Safeguard to ensure element is a valid jQuery object
        if (!element || !element.attr || element.length === 0) {
            console.warn("removeAllColCSS: Invalid or empty element provided.", element);
            return;
        }

        const currentClasses = element.attr("class") ? element.attr("class").split(" ") : [];
        const newClasses = [];

        for (let i = 0; i < currentClasses.length; i++) {
            // Check if the class does NOT start with 'col-'
            if (!currentClasses[i].startsWith('col-')) {
                newClasses.push(currentClasses[i]);
            }
        }
        // Replace all classes with the filtered list
        element.removeClass().addClass(newClasses.join(" "));
    }

    /**
     * Resizes the height of cart-related panels for small screen layouts.
     * Relies on SalesToolkit.Theme properties.
     */
    function resizeCartPanelsHeight() {
        $('#saved-carts-panel').height(90 + SalesToolkit.Theme.getIntegerProperty('savedCartPanelHeightSmallScreen', 150));
        $('#saved-carts-wrapper').height(SalesToolkit.Theme.getIntegerProperty('savedCartPanelHeightSmallScreen', 150) - 62);

        // Calculate main panel height based on main-div-center and saved-carts-panel heights
        const mainDivCenterHeight = $('#main-div-center').height();
        const savedCartsPanelHeight = $('#saved-carts-panel').height();

        if (mainDivCenterHeight !== null && mainDivCenterHeight !== undefined &&
            savedCartsPanelHeight !== null && savedCartsPanelHeight !== undefined) {
            $('#main-panel').height(mainDivCenterHeight - savedCartsPanelHeight);
        } else {
            console.warn("#main-div-center or #saved-carts-panel height is undefined, cannot set #main-panel height.");
        }

        // Calculate salestoolkit-cart-portlet height
        const mainPanelHeight = $('#main-panel').height();
        const mainPanelTitleHeight = $('#main-panel .portlet-title').height();

        if (mainPanelHeight !== null && mainPanelHeight !== undefined &&
            mainPanelTitleHeight !== null && mainPanelTitleHeight !== undefined) {
            $('#salestoolkit-cart-portlet').height(mainPanelHeight - mainPanelTitleHeight - 80);
        } else {
            console.warn("#main-panel or its title height is undefined, cannot set #salestoolkit-cart-portlet height.");
        }

        try {
            // Apply CSS properties using .css() for better control, especially with !important
            $('#salestoolkit-cart-portlet').css('min-height', '0 !important');
            $('#salestoolkit-cart-portlet').css('overflow', 'scroll');
            // Ensure the parent of salestoolkit-cart-portlet also gets min-height
            $('#salestoolkit-cart-portlet').parent().css('min-height', '0 !important');
            $('#main-panel .portlet-title').css('display', 'flex');
            $('#main-panel .portlet-title .actions').css('margin-left', 'auto');

        } catch (err) {
            console.error("Error applying styles in resizeCartPanelsHeight:", err);
        }
    }

    /**
     * Resizes the height of cart panels for big screen layouts.
     * Relies on SalesToolkit.Theme properties.
     */
    function resizeCartPanelBigScreen() {
        // Ensure SalesToolkit is available
        if (SalesToolkit.Theme.getBooleanProperty('resizeCartBigScreen', false)) {
            $('#saved-carts-panel .portlet.light').height($('#main-panel').height() - 16);
        }
    }

    /**
      * Helper function to check if simplified cart saving permission is available.
      * This function is expected to be globally available.
      */
    function _hasSimplifiedCartSavingPermission() {
        // Check if the global function exists before calling it
        if (typeof hasSimplifiedCartSavingPermission === 'function') {
            return hasSimplifiedCartSavingPermission();
        }
        console.warn("Global function '_hasSimplifiedCartSavingPermission' not found. Defaulting to false.");
        return false;
    }

    /**
     * Sets up the column layout for saved carts and main content panels
     * based on user permissions and screen size.
     */
    function setupColumns() {
        // Remove existing column classes from savedCarts panel
        removeAllColCSS(savedCarts);

        // Apply responsive column classes to savedCarts panel
        $(savedCarts).addClass('col-xl-' + savedCartsUltraLargeCols);
        $(savedCarts).addClass('col-lg-' + savedCartsLargeCols);
        $(savedCarts).addClass('col-md-' + savedCartsMediumCols);
        $(savedCarts).addClass('col-sm-' + savedCartsSmallCols);

        // Determine main panel column sizes based on permissions
        if (SalesToolkit.User.permissions.canViewCarts || _hasSimplifiedCartSavingPermission()) {
            let mainXLSize = 12 - savedCartsUltraLargeCols;
            let mainLGSize = 12 - savedCartsLargeCols;
            let mainMDSize = 12 - savedCartsMediumCols;
            let mainSMSize = 12 - savedCartsSmallCols;

            // Remove existing column classes from main panel
            removeAllColCSS(main);

            // Apply responsive column classes to main panel
            $(main).addClass('col-xl-' + mainXLSize);
            $(main).addClass('col-lg-' + mainLGSize);
            $(main).addClass('col-md-' + mainMDSize);
            $(main).addClass('col-sm-' + mainSMSize);

            $(savedCarts).show(); // Show the saved carts panel
            $('body').toggleClass('showingSavedCarts', true); // Add class to body for global styling
        } else {
            // If user doesn't have permissions, main panel takes full width
            removeAllColCSS(main);
            $(main).addClass('col-xl-12'); // Assuming 12 for all sizes when savedCarts is hidden
            $(main).addClass('col-lg-12');
            $(main).addClass('col-md-12');
            $(main).addClass('col-sm-12');

            $(savedCarts).hide(); // Hide the saved carts panel
            $('body').toggleClass('showingSavedCarts', false); // Remove class from body
        }

        // Apply side padding based on screen width
        $('#saved-carts-panel .portlet.light').toggleClass('sidePadding10', screen.width < 768);

        // Handle panel resizing based on screen size and theme properties
        const smallScreenCartPanels = screen.width < 768 &&
            SalesToolkit.Theme.getBooleanProperty('showCartsPanelSmall', true) &&
            (SalesToolkit.User.permissions.canViewCarts || _hasSimplifiedCartSavingPermission());

        if (smallScreenCartPanels) {
            // Delay for 500ms to allow DOM to settle after column changes
            setTimeout(function () {
                resizeCartPanelsHeight();
            }, 500);
        } else {
            // Delay for 500ms for big screen resize
            setTimeout(function () {
                resizeCartPanelBigScreen();
            }, 500);
        }
    }
    //#endregion PANELS

    //#region REMOTE COMPLETION
    function _checkRemoteCompletionEnd(completed = true) {
        if (remoteCompletionWaiting) {
            remoteCompletionWaiting = false;

            clearTimeout(mainTimeoutId);
            clearInterval(countdownIntervalId);
            clearInterval(pollingIntervalId);
            clearTimeout(countdownStarterId);

            let cart = SalesToolkit.Cart.getLoadedCart();

            if (typeof cart === 'undefined')
                SalesToolkit.Cart.empty();
            salestoolkitUICart.refresh();
            SalesToolkit.UI.Cart.updateMenuCartBadge();

            activityEvents.forEach(eventType => {
                window.removeEventListener(eventType, _handleUserActivity);
            });

            let notificationsToShow = [];
            let notificationBody = completed ? SalesToolkit.Translation.get('remoteCompletionFinishedSuccess', 'Remote completion was successful') : SalesToolkit.Translation.get('remoteCompletionTimeoutMessage', 'Remote completion timed out - if the qr code was scanned you can still complete it on your phone.');
            notificationsToShow.push([{ body: notificationBody, title: "", type: "cart" }]);
            localStorage["notificationsToShow"] = JSON.stringify(notificationsToShow);
            _disableButtonsIfCartEmpty();
            _cartModuleGoBack();
        }
    }

    function _startRemoteCompletion(requestId) {
        const span = $('#externalQRCode');

        remoteCompletionWaiting = true;

        activityEvents.forEach(eventType => {
            window.addEventListener(eventType, _handleUserActivity);
        });

        span.text(SalesToolkit.Translation.get('remoteCompletionWaiting', 'Waiting for remote completion...'));

        pollingIntervalId = setInterval(() => {
            SalesToolkit.API.pollRemoteCompletionStatus(requestId, {
                success: function (json) {
                    let count = json.count;
                    let countToWaitFor = SalesToolkit.Theme.getIntegerProperty('remoteCompletionCountToWaitFor', 1);

                     if (json.singleUse === true  && json.complete === true) {
                        _checkRemoteCompletionEnd(true); // End successfully
                    } else if(json.singleUse === false && count >= countToWaitFor){
                        _checkRemoteCompletionEnd(true); // End successfully
                    }
                    // If not complete, do nothing and wait for the next poll
                },
                failure: function (reason, httpstatus, errorCode) {
                    console.error("Could not poll for remote completion:", reason);
                }
            });
        }, 5000);
        _resetTimer();
    }

    /**
     * Resets the inactivity timer. Called on start and on user activity.
     */
    function _resetTimer() {
        clearTimeout(mainTimeoutId);
        clearInterval(countdownIntervalId);
        clearTimeout(countdownStarterId);
        console.log("Inactivity timer reset due to user activity.");

        const span = $('#externalQRCode');
        span.text(SalesToolkit.Translation.get('remoteCompletionWaiting', 'Waiting for remote completion...'));

        const timeoutInMS = SalesToolkit.Theme.getIntegerProperty('remoteCompletionTimeout', 60000);
        const warningTimeInMS = SalesToolkit.Theme.getIntegerProperty('remoteCompletionCountdownTime', 1000 * 10);

        // Set the main timeout that calls checkRemoteCompletionEnd with 'false' for timeout
        mainTimeoutId = setTimeout(() => _checkRemoteCompletionEnd(false), timeoutInMS);

        // Set a timeout to start the 10-second warning countdown
        const countdownStartTime = timeoutInMS - warningTimeInMS;
        countdownStarterId = setTimeout(() => startCountdown(warningTimeInMS), countdownStartTime);
    }

    /**
     * The single handler for any user activity. It just calls _resetTimer.
     */
    function _handleUserActivity() {
        _resetTimer();
    }

    /**
     * Starts the visual countdown on the screen.
     * @param {number} warningTimeInMS - The duration of the countdown in milliseconds.
     */
    function startCountdown(warningTimeInMS) {
        if (!remoteCompletionWaiting) return; // Don't start countdown if process already ended
        let secondsLeft = warningTimeInMS / 1000;
        const span = $('#externalQRCode');

        span.html(SalesToolkit.Translation.getFormatted('remoteCompletionCountdown', 'This screen will close in {0} seconds', [secondsLeft]));

        countdownIntervalId = setInterval(() => {
            secondsLeft--;
            if (secondsLeft > 0) {
                span.html(SalesToolkit.Translation.getFormatted('remoteCompletionCountdown', 'This screen will close in {0} seconds', [secondsLeft]));
            } else {
                clearInterval(countdownIntervalId);
            }
        }, 1000);
    }
    //#endregion

    //#region Click Handlers
    function handleBasicClick(e) {
        if (!$(e.target).hasClass('modal-dialog') && $(e.target).parents(".modal-dialog").length == 0) {
            if (SalesToolkit.Theme.getBooleanProperty('preventClosingCartPopupOnOutisdeClick', false)) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
            }
        }
    }

    function handleShareLinkPopupClick(e) {
        if (!$(e.target).hasClass('modal-dialog') && $(e.target).parents(".modal-dialog").length == 0) {
            if (SalesToolkit.Theme.getBooleanProperty('preventClosingCartPopupOnOutisdeClick', false)) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
            }
        }
    }

    function _handleFullscreenClick(e) {
        $(this).tooltip('destroy').tooltip({ placement: 'top' });
        let tooltips = document.querySelectorAll("body > .tooltip");
        for (let i = 0; i < tooltips.length; i++) {
            $(tooltips[i]).remove();
        }
    }

    //#endregion

    //#region UI Setup
    function _setupCartFeaturesAndModals() {
        // Hide all cart feature elements initially
        $('#salestoolkit-share-cart').hide();
        $('#salestoolkit-registerInterest-cart').hide();
        $('#salestoolkit-mlr-cart').hide();

        // Show elements based on user permissions
        if (SalesToolkit.User.permissions.canRegisterInterest) {
            $('#salestoolkit-registerInterest-cart').show();
        }

        if (SalesToolkit.User.permissions.canMLR) {
            $('#salestoolkit-mlr-cart').show();
        }

        if (SalesToolkit.User.permissions.canShare) {
            $('#salestoolkit-share-cart').show();
        }

        // Adjust #basic modal styling based on theme properties and screen width
        if (!SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) &&
            SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false)) {

            $('#basic').css('top', '0%');
            $('#basic .modal-dialog').css('width', "90vw");

            if (SalesToolkit.Theme.getBooleanProperty('formPopupFitContent', true)) {
                $('#basic .modal-dialog').css('width', "fit-content");
            }

            let cssPropertyName = "Desktop";
            if (screen.width <= 1024) {
                //Tablet
                cssPropertyName = "Tablet";
                //Mobile
                if (screen.width <= 720) {
                    cssPropertyName = "Mobile";
                }
            }

            if (SalesToolkit.Theme.getIntegerProperty('forcePopupWidth' + cssPropertyName, 0) > 0) {
                $('#basic .modal-dialog').css('width', SalesToolkit.Theme.getIntegerProperty('forcePopupWidth' + cssPropertyName, 0) + "vw");
            }

            $('#emailAddressesLabel').hide();
            $('#salestoolkit-email-addresses-div').hide();
            $('#salestoolkit-form-fields-div').css('margin-top', '10px');
        }

        FAVOURITES_HEART_FULL = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconFavouritesFilled', 'img/default/favourites_full_icon.svg');
        FAVOURITES_HEART_EMPTY = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconFavourites', 'img/default/favourites_empty_icon_sml.svg');
        REMOVE_ICON = SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconRemoveCart', SalesToolkit.Theme.getStringProperty('salestoolkitAssetTileIconRemove', 'img/default/bin_icon.svg'));

        if (SalesToolkit.Theme.getBooleanProperty("allowShareLinkInCart", true)) {
            $('#salestoolkit-sharelink').show();
            singleEmailMode = true; // This variable's scope is currently limited to this function
        } else {
            $('#salestoolkit-sharelink').hide();
        }

        if (SalesToolkit.Theme.getBooleanProperty('hideCartCustomiseEmail', false)) {
            $('.sendcartEmailcustom').hide();
        } else {
            $('.sendcartEmailcustom').show();
        }

        if (SalesToolkit.Theme.getBooleanProperty('hideCartSendCopy', false)) {
            $('#salestoolkit-me-too-checkbox').parents('.pull-left').hide();
        } else {
            $('#salestoolkit-me-too-checkbox').parents('.pull-left').show();
        }

        // Call global setKioskMode function
        if (typeof setKioskMode === 'function') {
            setKioskMode();
        } else {
            console.warn("Global function 'setKioskMode' not found.");
        }


        if (SalesToolkit.CrossPlatform.enabled) {
            if (document.getElementById('contactEmailHint')) {
                document.getElementById('contactEmailHint').style.display = "block";
            } else {
                console.warn("#contactEmailHint element not found.");
            }


            // Helper function for image URL rewriting to avoid repetition
            const rewriteImageSrc = (originalUrl, targetSelector, globalVarName) => {
                if (typeof addUrlToRewriteQueue === 'function') {
                    if (!SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(originalUrl)) {
                        addUrlToRewriteQueue(originalUrl, function (rewrittenURL) {
                            $(targetSelector + '[src="' + originalUrl + '"]').attr('src', rewrittenURL);
                            // Update the local variable within this scope for consistency if needed
                            // For global variables, this would require a different approach or exposing them.
                            // For now, these are local to this function.
                            if (globalVarName === 'FAVOURITES_HEART_FULL') FAVOURITES_HEART_FULL = rewrittenURL;
                            if (globalVarName === 'FAVOURITES_HEART_EMPTY') FAVOURITES_HEART_EMPTY = rewrittenURL;
                            if (globalVarName === 'REMOVE_ICON') REMOVE_ICON = rewrittenURL;
                        });
                    } else {
                        const rewrittenURL = SalesToolkit.CrossPlatform.urlRewriteCache[originalUrl];
                        $(targetSelector + '[src="' + originalUrl + '"]').attr('src', rewrittenURL);
                        if (globalVarName === 'FAVOURITES_HEART_FULL') FAVOURITES_HEART_FULL = rewrittenURL;
                        if (globalVarName === 'FAVOURITES_HEART_EMPTY') FAVOURITES_HEART_EMPTY = rewrittenURL;
                        if (globalVarName === 'REMOVE_ICON') REMOVE_ICON = rewrittenURL;
                    }
                } else {
                    console.warn("Global function 'addUrlToRewriteQueue' not found. Image rewriting skipped for:", originalUrl);
                }
            };

            // Apply rewriting for each icon
            rewriteImageSrc(FAVOURITES_HEART_FULL, 'img', 'FAVOURITES_HEART_FULL');
            rewriteImageSrc(FAVOURITES_HEART_EMPTY, 'img', 'FAVOURITES_HEART_EMPTY');
            rewriteImageSrc(REMOVE_ICON, 'img', 'REMOVE_ICON');

        } else {
            console.warn("SalesToolkit.CrossPlatform not enabled or found, skipping CrossPlatform specific logic.");
        }
    }

    //#endregion

    //#region Helper functions
    let _originalGoBack = null; // To store the original global goBack function

    /**
     * Private function to handle disabling/enabling cart action buttons
     * based on whether the cart is empty or has a loaded cart.
     */
    function _disableButtonsIfCartEmpty() {

        const emptyCart = !SalesToolkit.Cart.assetIds || SalesToolkit.Cart.assetIds.length === 0;

        const buttonsToManage = [
            'salestoolkit-empty-cart',
            'salestoolkit-share-cart',
            'salestoolkit-registerInterest-cart',
            'salestoolkit-mlr-cart',
            'salestoolkit-camera',
            'salestoolkit-save-cart'
        ];

        buttonsToManage.forEach(id => {
            const element = document.getElementById(id);
            if (element) {
                if (emptyCart) {
                    element.classList.add('disabled');
                } else {
                    element.classList.remove('disabled');
                }
            } else {
                console.warn(`Element with ID '${id}' not found for button management.`);
            }
        });

        // Specific logic for 'salestoolkit-save-cart' visibility based on permissions
        if (!SalesToolkit.User.permissions.canSaveCarts) {
            $('#salestoolkit-save-cart').hide();
        } else {
            // Ensure it's shown if permission exists and it wasn't hidden by empty cart logic
            if (!emptyCart) { // Only show if not empty and has permission
                $('#salestoolkit-save-cart').show();
            }
        }

        // Additional logic for 'salestoolkit-empty-cart' if a cart is loaded
        if (SalesToolkit.User.permissions.canViewCarts || SalesToolkit.User.permissions.canSaveCarts) {
            let cart = SalesToolkit.Cart.getLoadedCart();
            if (typeof cart !== 'undefined') {
                const emptyCartButton = document.getElementById('salestoolkit-empty-cart');
                if (emptyCartButton) {
                    emptyCartButton.classList.add('disabled');
                }
            }
        }
    }

    /**
     * Private function for the cart module's specific goBack logic.
     * This will be assigned to the global window.goBack when the module initializes.
     */
    function _cartModuleGoBack() {
        // Use the global loadContent function if it exists, otherwise fall back to page reload.
        if (typeof loadContent === 'function') {
            // Update the URL with the required parameters without reloading the page.
            const newUrl = 'index.html?loadCB=1&cartBackButton=true';
            window.history.replaceState({ path: newUrl }, '', newUrl);
            loadContent('index');
        } else {
            console.error('loadContent function is not available. Falling back to page reload.');
            window.location.href = "index.html?loadCB=1&cartBackButton=true";
        }
        return false;
    }


    //#endregion

    //#region salestoolkitUICart 
    function _onInfoRequested(item) {
        if (typeof showInformationForItem === 'function') {
            showInformationForItem(item);
        } else {
            console.warn("Global function 'showInformationForItem' not found.");
        }
    }

    function _onItemAdded(item) {
        let itemElement = document.querySelector('#salestoolkit-cart-portlet .atheneum-item[data-atheneum-item-id="' + item.id + '"]');
        if (itemElement) {
            let thumbnailElement = itemElement.querySelector('.thumbnail');
            if (thumbnailElement) {
                let bgImageURL = thumbnailElement.getAttribute('data-background-image-url');
                if (bgImageURL && typeof addUrlToRewriteQueue === 'function') {
                    addUrlToRewriteQueue(bgImageURL, function (rewrittenURL) {
                        let finalURL = rewrittenURL;
                        if (finalURL !== null && finalURL.includes("https:") && !finalURL.includes("keepRatio=true&shouldCrop=false&width=800&height=450")) {
                            finalURL = finalURL + "?keepRatio=true&shouldCrop=false&width=800&height=450";
                        }
                        thumbnailElement.style.backgroundImage = 'url(\'' + finalURL + '\')';
                        thumbnailElement.style.opacity = 1;
                    });
                }
            }

            let infoIconElement = itemElement.querySelector('.atheneum-item .asset-style .info-btn img');
            if (infoIconElement) {
                if (SalesToolkit.Theme.getBooleanProperty('hideAssetInformationButton', false)) {
                    infoIconElement.style.display = 'none';
                } else {
                    if (typeof applyImageToElement === 'function') {
                        applyImageToElement(infoIconElement, 'assetInformationIcon', 'img/default/info_icon.svg');
                    } else {
                        console.warn("Global function 'applyImageToElement' not found.");
                    }
                    infoIconElement.style.display = 'block';
                }
            }

            if (SalesToolkit.CrossPlatform.enabled) {
                const rewriteImageSrc = (originalUrl, targetSelector, globalVarName) => { // globalVarName is now just a string for reference
                    if (typeof addUrlToRewriteQueue === 'function') {
                        if (!SalesToolkit.CrossPlatform.urlRewriteCache.hasOwnProperty(originalUrl)) {
                            addUrlToRewriteQueue(originalUrl, function (rewrittenURL) {
                                $(targetSelector + '[src="' + originalUrl + '"]').attr('src', rewrittenURL);
                                // Update the module's private variable reference directly
                                if (globalVarName === 'FAVOURITES_HEART_FULL') FAVOURITES_HEART_FULL = rewrittenURL;
                                if (globalVarName === 'FAVOURITES_HEART_EMPTY') FAVOURITES_HEART_EMPTY = rewrittenURL;
                                if (globalVarName === 'REMOVE_ICON') REMOVE_ICON = rewrittenURL;
                            });
                        } else {
                            const rewrittenURL = SalesToolkit.CrossPlatform.urlRewriteCache[originalUrl];
                            $(targetSelector + '[src="' + originalUrl + '"]').attr('src', rewrittenURL);
                            if (globalVarName === 'FAVOURITES_HEART_FULL') FAVOURITES_HEART_FULL = rewrittenURL;
                            if (globalVarName === 'FAVOURITES_HEART_EMPTY') FAVOURITES_HEART_EMPTY = rewrittenURL;
                            if (globalVarName === 'REMOVE_ICON') REMOVE_ICON = rewrittenURL;
                        }
                    } else {
                        console.warn("Global function 'addUrlToRewriteQueue' not found. Image rewriting skipped for:", originalUrl);
                    }
                };

                // Apply rewriting for each icon using the module's private variables
                rewriteImageSrc(FAVOURITES_HEART_FULL, 'img', 'FAVOURITES_HEART_FULL');
                rewriteImageSrc(FAVOURITES_HEART_EMPTY, 'img', 'FAVOURITES_HEART_EMPTY');
                rewriteImageSrc(REMOVE_ICON, 'img', 'REMOVE_ICON');
            }

            const removeIconElement = itemElement.querySelector('.remove-icon');
            if (removeIconElement) {
                removeIconElement.src = REMOVE_ICON;
            }

            if (typeof _loadCartPanel === 'function') {
                _loadCartPanel();
            } else {
                console.warn("Global function 'loadCartPanel' not found.");
            }
        }
    }

    function _onRefresh() {
        let tooltips = document.querySelectorAll("body > .tooltip");
        for (let i = 0; i < tooltips.length; i++) {
            $(tooltips[i]).remove();
        }
    }

    function _onItemRemovedFromCart() {
        let tooltips = document.querySelectorAll("body > .tooltip");
        for (let i = 0; i < tooltips.length; i++) {
            $(tooltips[i]).remove();
        }
        if (typeof _loadCartPanel === 'function') {
            _loadCartPanel();
        } else {
            console.warn("Global function 'loadCartPanel' not found.");
        }
    }

    function _onItemUpdateFavButton(item) {
        let favButton = document.querySelector("[data-atheneum-item-id=\"" + item.id + "\"] [data-atheneum-item-action=\"toggle-favourite\"]");
        if (!favButton) return; // Exit if button not found

        let favImage = favButton.querySelector("img");

        if (SalesToolkit.Favourites.assetIds.includes(item.id)) { // Use .includes() for arrays
            if (!favButton.className.includes("already-clicked")) { // Use .includes() for string check
                favButton.className += " already-clicked";
            }
            favButton.setAttribute("title", SalesToolkit.Translation.get('favouritesToggleRemove', 'Remove from Favourites'));
            if (favImage) {
                $(favImage).attr("src", FAVOURITES_HEART_FULL);
            }
        } else {
            if (favButton.className.includes("already-clicked")) {
                favButton.className = favButton.className.replace("already-clicked", "").trim(); // .trim() to clean up spaces
            }
            favButton.setAttribute("title", SalesToolkit.Translation.get('favouritesToggleAdd', 'Add to Favourites'));
            if (favImage) {
                $(favImage).attr("src", FAVOURITES_HEART_EMPTY);
            }
        }
    }

    function _onItemAddedTriggerFavButton(item) {
        if (salestoolkitUICartInstance) {
            salestoolkitUICartInstance.trigger("item-update-fav-button", item);
        }
    }

    function _onItemActionViewClick(item) {
        if (item.type == "asset" && !SalesToolkit.Library.assets[item.id].canPreview) {
            return false;
        }

        if (item.type === "asset" && SalesToolkit.Pages.PreviewAssetPage.url) {
            loadAssetScreen(item.id, "?from=cart");
        } else if (item.type === "collection" && SalesToolkit.Pages.ExploreCollectionPage.url) {
            loadIndexScreen(false, false, item.id, false);
        }
        return false;
    }

    function _onItemActionFailure(item, action, details) {
        if (action == "add-to-favourites" && Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) {
            let notificationBody = SalesToolkit.Translation.getFormatted('notificationFavouritesAdded', 'Added {0} to Favourites', [item.name]);
            SalesToolkit.UI.Notifications.showCustomNotification("favourites", notificationBody);
            if (salestoolkitUICartInstance) {
                salestoolkitUICartInstance.trigger("item-added-to-favourites", item);
            }
        }

        if (action == "remove-from-favourites" && Atheneum.Callbacks.isOffline(details.reason, details.httpStatus, details.errorCode)) {
            let notificationBody = SalesToolkit.Translation.getFormatted('notificationFavouritesAdded', 'Removed {0} from Favourites', [item.name]);
            SalesToolkit.UI.Notifications.showCustomNotification("favourites", notificationBody);
            if (salestoolkitUICartInstance) {
                salestoolkitUICartInstance.trigger("item-removed-from-favourites", item);
            }
        }
    }

    function _onItemActionClick(item, action) {
        let button = document.querySelector("[data-atheneum-item-id=\"" + item.id + "\"] [data-atheneum-item-action=\"" + action + "\"]");
        if (button) {
            button.blur();
        }
    }

    function _onItemAddedToFavourites(item) {
        if (salestoolkitUICartInstance) {
            salestoolkitUICartInstance.trigger("item-update-fav-button", item);
        }
        let favButtonImg = document.querySelector("[data-atheneum-item-id=\"" + item.id + "\"] [data-atheneum-item-action=\"toggle-favourite\"] img");
        if (favButtonImg) {
            $(favButtonImg).attr("src", FAVOURITES_HEART_FULL);
        }
    }

    function _onItemRemovedFromFavourites(item) {
        if (salestoolkitUICartInstance) {
            salestoolkitUICartInstance.trigger("item-update-fav-button", item);
        }
        let favButtonImg = document.querySelector("[data-atheneum-item-id=\"" + item.id + "\"] [data-atheneum-item-action=\"toggle-favourite\"] img");
        if (favButtonImg) {
            $(favButtonImg).attr("src", FAVOURITES_HEART_EMPTY);
        }
    }
    //#endregion


    //#region CAMERA SCANNING
    async function _openedCameraModal() {
        trackAppClick($('#salestoolkit-camera'), '#salestoolkit-camera', 'trackingCameraModal', SalesToolkit.Translation.get('trackingCameraModal', 'trackingCameraModal'));
        $('#scan-info').hide();
        $('#scan-info').text('');
        let result = await cardReader.startStream(SalesToolkit.Theme.getBooleanProperty('scannerPreferBackCamera', true));
        if (!result) {
            let notificationBody = SalesToolkit.Translation.get('notificationNoDeviceFound', 'No camera found');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
        } else {

            $('#cameraModal').modal('show');

            setTimeout(function () {
                if (SalesToolkit.Theme.getBooleanProperty('useScanOverlay', false)) {

                    $('#scanAreaDark').width($('#cameraFeedVideo').width());
                    $('#scanAreaDark').height($('#cameraFeedVideo').height());
                    $('#scanAreaDark').offset($('#cameraFeedVideo').offset());

                    $('#scanAreaLight').width(SalesToolkit.Theme.getIntegerProperty('scanAreaWidth', 300) + 'px');
                    $('#scanAreaLight').height(SalesToolkit.Theme.getIntegerProperty('scanAreaHeight', 300) + 'px');

                    $('#scanAreaDark').show();
                }
            }, 500);

            if (SalesToolkit.Theme.getBooleanProperty('scanAutomaticallyCart', false)) {
                setTimeout(_takeScan, 500, true);
            }
        }
    }

    function _resizeHandler() {
        if (SalesToolkit.Theme.getBooleanProperty('useScanOverlay', false)) {

            $('#scanAreaDark').width($('#cameraFeedVideo').width());
            $('#scanAreaDark').height($('#cameraFeedVideo').height());
            $('#scanAreaDark').offset($('#cameraFeedVideo').offset());

            $('#scanAreaLight').width(SalesToolkit.Theme.getIntegerProperty('scanAreaWidth', 300) + 'px');
            $('#scanAreaLight').height(SalesToolkit.Theme.getIntegerProperty('scanAreaHeight', 300) + 'px');

            $('#scanAreaDark').show();
        }

        savedCartsSmallCols = SalesToolkit.Theme.getBooleanProperty('showCartsPanelSmall', true);

        if (screen.width >= 768 && screen.width < 991)
            savedCartsSmallCols = SalesToolkit.Theme.getIntegerProperty('savedCartsPanelSmallCols', 4);
        else if (screen.width >= 768)
            savedCartsSmallCols = 0;
        else if (savedCartsSmallCols)
            savedCartsSmallCols = 12;
        else
            savedCartsSmallCols = 0;

        setupColumns();

        if (typeof _loadCartPanel === 'function') {
            _loadCartPanel();
            setTimeout(function () {
                _loadCartPanel();
            }, 300);
        }

        if (typeof _originalOnResize === 'function') {
            setTimeout(_originalOnResize, 300);
        }
    }

    function _stopCamera() {
        if (cardReader) {
            cardReader.stopStream();
        }
        $('#scan-info').hide();
        $('#scan-info').text('');
    }

    async function _takeScan(autoScan = false) {

        if (cardReader.stream == null)
            return;
        //Take a snapshot of the video feed
        let imageUrl = cardReader.getImage();
        cardReader.form = getCartShareForm();

        if (SalesToolkit.Theme.getBooleanProperty('scanForBarcodesCart', false)) {
            //Convert to a blob and then to a file object

            try {
                let imageCrop = cardReader.getCropAreaImage(SalesToolkit.Theme.getIntegerProperty('scanAreaWidth', 300), SalesToolkit.Theme.getIntegerProperty('scanAreaHeight', 300));
                let blob = await fetch(imageCrop).then(it => it.blob());
                let imageFile = new File([blob], "scan", { type: "image/jpeg" });
                //attempt to scan the image file for qr codes or barcodes
                let decodedText = await html5QrCode.scanFile(imageFile, true);
                if (decodedText !== undefined && decodedText.length > 0) {

                    let autoScanning = autoScan;

                    SalesToolkit.Badges.lookup(decodedText, {
                        success: function (badge) {

                            $('#cameraModal').modal('hide');
                            _openShareModal();
                            $('#basic').modal('show');

                            populateFormWithBadgeData($('#salestoolkit-email-addresses-div'), badge);
                            populateFormWithBadgeData($('#salestoolkit-form-fields-div'), badge);

                            $('#salestoolkit-form-fields-div').find('input[data-type="BADGE"]').val(decodedText)

                            let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilled', 'Share form information updated');
                            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                            _stopCamera();
                        },
                        failure: function (reason, httpStatus, errorCode) {
                            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Badges.lookup");

                            if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {

                                let popupText = SalesToolkit.Theme.getStringProperty("badgeScanOffline",
                                    "No internet connection available, please try again once a connection "
                                    + "has been established or complete the form manually. Thank you"
                                );

                                $('#scan-info').text(popupText);
                                $('#scan-info').css('display', 'block');
                            } else {
                                let errorCodeHex = undefined;
                                if (typeof errorCode == 'number') {
                                    errorCodeHex = errorCode.toString(16);
                                    while (errorCodeHex.length < 8) {
                                        errorCodeHex = '0' + errorCodeHex;
                                    }
                                }
                                let message = SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, SalesToolkit.Translation.get('badgeScanError', 'Ran into an error while scanning badge'));
                                if (SalesToolkit.Theme.getBooleanProperty("includeErrorCodeForBadgeScan", true) && (message === SalesToolkit.Translation.get('badgeScanError', 'Ran into an error while scanning badge'))) {
                                    message += " - " + errorCode;
                                }

                                $('#scan-info').text(message);
                                $('#scan-info').css('display', 'block');
                            }

                            if (autoScanning) {
                                setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
                            }
                        },
                        offline: function (reason, httpstatus, errorCode) {
                            Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Badges.lookup");

                            let popupText = SalesToolkit.Theme.getStringProperty("badgeScanOffline",
                                "No internet connection available, please try again once a connection "
                                + "has been established or complete the form manually. Thank you"
                            );

                            $('#scan-info').text(popupText);
                            $('#scan-info').css('display', 'block');
                            if (autoScanning) {
                                setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
                            }
                        }
                    });
                }

                return;
            } catch (err) {
                console.log('error trying to decode qr / bar code');
            }
        }

        if (!SalesToolkit.Theme.getBooleanProperty('scanForBusinessCardsCart', true)) {
            if (autoScan && SalesToolkit.Theme.getBooleanProperty('scanForBarcodesCart', false)) {

                //Only scanning barcodes / qr codes
                $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderNoBadge', 'Badge not detected'));
                $('#scan-info').css('display', 'block');
                setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
            }

            return;
        }

        if (SalesToolkit.Theme.getBooleanProperty('scanForBusinessCardsCart', true) && SalesToolkit.Theme.getBooleanProperty('busScanningManualOnly', true) && autoScan) {
            $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderNoBadgeNoAutoBus', 'Badge not detected. If scanning a business card please position and use the Take Picture button'));
            $('#scan-info').css('display', 'block');
            setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
            return;
        }

        try {

            let result = await cardReader.getCardDetails(imageUrl);
            if (SalesToolkit.Theme.getBooleanProperty('rejectCardsWithoutEmailCart', false) && (!result.hasOwnProperty('emails') || result.emails.length == 0)) {
                if (!autoScan) {
                    let notificationBody = SalesToolkit.Translation.get('notificationCardReaderErrorNoEmail', 'Could not get an email address from the business card');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                } else {
                    $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderErrorNoEmail', 'Could not get an email address from the business card'));
                    $('#scan-info').css('display', 'block');
                    setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
                }
                return;
            }
            let populatedFromCard = false;
            window.populatedImage = imageUrl;

            if (typeof checkForTitleBug == 'function')
                result = checkForTitleBug(result);


            //Populate the form from details retrieved from the business card directly
            if (SalesToolkit.Theme.getBooleanProperty('useCardDetailsDirectlyCart', false)) {

                $('#cameraModal').modal('hide');
                _openShareModal();
                $('#basic').modal('show');
                try {
                    populateFormFromScan($('#salestoolkit-email-addresses-div'), result);
                } catch (err) {

                }
                populateFormFromScan($('#salestoolkit-form-fields-div'), result);

                if (!SalesToolkit.Theme.getBooleanProperty('scanForContactsTooCart', true)) {
                    let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilled', 'Share form information updated');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    _stopCamera();
                    return;
                } else {
                    _stopCamera();
                    populatedFromCard = true;
                }

            }

            await window.atheneumGL.performLookupFromScanResults(result);

            // //Otherwise try to find a contact matching the info 	
            // let firstName = result.firstName;
            // let lastName = result.lastName;
            // let emails = result.emails;
            // let phones = result.phones;
            // let company = '';
            // try {
            //     company = result.jobs[0].company;
            // } catch (err) {
            //     company - '';
            // }

            // let TRUE_VALUES = ['on', 'true', 'y', 'yes', true];



            // let contacts;

            // if (SalesToolkit.Contacts.contactHelper) {
            //     try {
            //         const searchCriteria = {};

            //         // Conditionally add criteria if they are defined and have content
            //         if (firstName && typeof firstName === 'string' && firstName.trim() !== '') {
            //             searchCriteria.firstName = firstName;
            //         }
            //         if (lastName && typeof lastName === 'string' && lastName.trim() !== '') {
            //             searchCriteria.lastName = lastName;
            //         }
            //         if (emails && Array.isArray(emails) && emails.length > 0) {
            //             searchCriteria.emails = emails;
            //         }
            //         if (phones && Array.isArray(phones) && phones.length > 0) {
            //             searchCriteria.phones = phones;
            //         }
            //         if (company && typeof company === 'string' && company.trim() !== '') {
            //             searchCriteria.company = company;
            //         }

            //         // Call the new method to retrieve contacts based on multiple criteria
            //         contacts = await SalesToolkit.Contacts.contactHelper.getContactsByMultipleCriteria(searchCriteria);

            //     } catch (error) {
            //         console.error("Error retrieving contacts:", error);
            //         contacts = []; // Ensure contacts is an empty array on error
            //     }
            // } else {

            //     contacts = await SalesToolkit.Contacts.getById('', { exact: false });

            //     if (SalesToolkit.Contacts.__preferLiveQueryToCache) {
            //         try {
            //             //TODO get contacts but filtered via the current info through new api when available - on servers with long contacts list this will not be fast enough
            //             let json = await SalesToolkit.Contacts.getContactsAsync();
            //             if (json.errorCode == 0)
            //                 contacts = json.contacts;
            //             else {
            //                 contacts = await SalesToolkit.Contacts.getById('', { exact: false });
            //             }
            //         } catch (err) {
            //             contacts = await SalesToolkit.Contacts.getById('', { exact: false });
            //         }
            //     } else {
            //         contacts = await SalesToolkit.Contacts.getById('', { exact: false });
            //     }
            // }

            // if (Array.isArray(contacts) && !TRUE_VALUES.includes(SalesToolkit.User.test)) {
            //     contacts = contacts.filter(x => !x.hasOwnProperty('test') || !x.test)
            // }


            // let minimumSimilarity = SalesToolkit.Theme.getFloatProperty('minimumSimilarity', 1);
            // let contact = contacts.filter(x => _anySimilarEmails(emails, x.info?.email) || _anyMatchingPhones(phones, (x.info?.phone || x.info?.phoneNumber || x.info.phoneNo)));

            // if (!contact || contact.length == 0) {
            //     let companyFieldName = SalesToolkit.Theme.getStringProperty('companyContactFieldName', 'company');
            //     contact = contacts.filter(x => x.hasOwnProperty('info') && x.info.hasOwnProperty(companyFieldName) && _similarity(x.info[companyFieldName], company) >= minimumSimilarity);
            // } else if (contact.length > 1) {
            //     let companyFieldName = SalesToolkit.Theme.getStringProperty('companyContactFieldName', 'company');
            //     contact = contact.filter(x => x.hasOwnProperty('info') && x.info.hasOwnProperty(companyFieldName) && _similarity(x.info[companyFieldName], company) >= minimumSimilarity);
            // }

            // if (!contact || contact.length == 0) {
            //     contact = contacts.filter(x => _similarity(x.info?.firstName, firstName) >= minimumSimilarity && _similarity(x.info?.lastName, lastName) >= minimumSimilarity);
            // } else if (contact.length > 1) {
            //     contact = contact.filter(x => _similarity(x.info?.firstName, firstName) >= minimumSimilarity && _similarity(x.info?.lastName, lastName) >= minimumSimilarity);
            // }


            // if (contact.length > 1) {
            //     let atheneumContactOnly = contact.filter(x => x instanceof Atheneum.Contact);
            //     if (atheneumContactOnly.length > 0)
            //         contact = atheneumContactOnly;
            // }

            // if (contact && contact.length > 1) {
            //     let notificationBody = SalesToolkit.Translation.get('notificationCardReaderMultipleContacts', 'Multiple contacts found, please select from the suggestions');
            //     SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            //     _stopCamera();

            //     $('#cameraModal').modal('hide');

            //     if (SalesToolkit.Theme.getBooleanProperty('useContactFilterModal', true)) {
            //         currentContactFilters = contact;
            //         $('#contactFilterModal').modal('show');
            //         let step = 0;
            //         if (contact.length > 5 && contact.length < 10)
            //             step = 1;
            //         else if (contact.length <= 5)
            //             step = 2;
            //         _setupContactFilterModalForContacts(contact, step);
            //         return;
            //     }

            //     _openShareModal();
            //     $('#basic').modal('show');

            //     let $field = $('#salestoolkit-email-addresses-div').find("input[data-type='EMAIL']");
            //     if ($field.length == 0) {
            //         $field = $('#salestoolkit-form-fields-div').find("input[data-type='EMAIL']");
            //     }
            //     await showContactSuggestions($field, contact);
            //     return;
            // } else if (!contact || contact.length == 0) {
            //     if (populatedFromCard) {
            //         let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilled', 'Share form information updated');
            //         SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            //         _stopCamera();
            //         $('#cameraModal').modal('hide');
            //         return;
            //     } else if (!autoScan) {
            //         let notificationBody = SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan');
            //         SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            //         return;
            //     } else {

            //         if (SalesToolkit.Theme.getBooleanProperty('keepScanningOnContactFailureCart', false)) {
            //             $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan'));
            //             $('#scan-info').css('display', 'block');
            //             setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
            //         } else {
            //             let notificationBody = SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan');
            //             SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            //             $('#cameraModal').modal('hide');
            //             return;
            //         }
            //     }
            // } else {
            //     $('#cameraModal').modal('hide');
            //     _openShareModal();
            //     $('#basic').modal('show');

            //     populateFormWithContact($('#salestoolkit-email-addresses-div'), contact[0]);
            //     populateFormWithContact($('#salestoolkit-form-fields-div'), contact[0]);

            //     if (populatedFromCard) {
            //         let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilledBoth', 'Share form information updated from scan and matching contact');
            //         SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            //         _stopCamera();
            //         return;
            //     }


            //     let notificationBody = SalesToolkit.Translation.get('notificationCardReaderMatch', 'Contact loaded from scan');
            //     SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);

            //     _stopCamera();

            // }

        } catch (err) {
            if (!autoScan) {
                let notificationBody = SalesToolkit.Translation.get('notificationCardReaderError', 'No badge or business card detected');
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            } else {
                $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderError', 'No badge or business card detected'));
                $('#scan-info').css('display', 'block');
                setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
            }
        }
    }
    //#endregion

    //#region GLU
    function _showGlobalLookupFromFieldBlur(contacts, fieldsToReactTo) {
        let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
        if (Array.isArray(contacts) && !TRUE_VALUES.includes(SalesToolkit.User.test)) {
            contacts = contacts.filter(x => !x.hasOwnProperty('test') || !x.test)
        }

        let i;
        let $form = $('#salestoolkit-form-fields-div');
        let fieldSearch = {};
        for (i = 0; i < fieldsToReactTo.length; i++) {
            let fieldName = fieldsToReactTo[i];

            let $field = $form.find(
                'input[name="' + fieldName + '"]'
                + ', select[name="' + fieldName + '"]'
                + ', textarea[name="' + fieldName + '"]'
            );

            if ($field.length != 0) {
                $field = $($field[0]);
                if ($field.val() == '') {
                    console.log('All items need filling before filter opens');
                    return;
                } else {
                    fieldSearch[SalesToolkit.Theme.getStringProperty('customFieldNameConversion_' + fieldName, fieldName)] = $field.val().toLowerCase();
                    contacts = contacts.filter(x => x.info.hasOwnProperty(fieldName) && x.info[fieldName]?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == $field.val().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
                }
            } else {
                console.log('setup likely wrong for contact filtering modal through manual entry');
                return;
            }
        }

        if (SalesToolkit.Theme.getBooleanProperty('useVeevaContacts', false)) {
            let formType = $('#salestoolkit-form-fields-div').data('form-type');
            let form = _getFormByType(formType);
            let fieldsList = SalesToolkit.Contacts.getCustomFieldListForForm(form);
            _setupContactFilterModalForSearching();
            $('#contactFilterModal').modal('show');

            SalesToolkit.API.searchVeevaContacts(fieldsList, fieldSearch, {
                success: function (json) {
                    console.log(json);
                    if (json.hasOwnProperty('accounts')) {


                        for (const account of json.accounts) {
                            let contactIndex = contacts.findIndex(x => x.info.crmId === account.crmId);
                            let contact = contactIndex < 0 ? new Atheneum.Contact({}) : contacts[contactIndex];

                            for (const key in account) {
                                if (account.hasOwnProperty(key) && typeof account[key] !== 'undefined') {
                                    contact.info[key] = account[key];
                                }
                            }

                            if (contactIndex < 0)
                                contacts.push(contact);
                            else
                                contacts[contactIndex] = contact;
                        }
                    }

                    if (contacts.length === 0) {
                        let title = SalesToolkit.Translation.getOrGetThemeKey('searchingExternalContactsNoMatches', 'Search Complete');
                        let message = SalesToolkit.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'No matching contacts found');

                        SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
                    }

                    let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
                    if (atheneumContactOnly.length > 0)
                        contacts = atheneumContactOnly;

                    currentContactFilters = contacts;

                    let step = 0;
                    if (contacts.length > 5 && contacts.length < 10)
                        step = 1;
                    else if (contacts.length <= 5)
                        step = 2;

                    _setupContactFilterModalForContacts(contacts, step);
                    $('#restartButton').show();
                },
                failure: function (reason, httpStatus, errorCode) {
                    $('#contactFilterModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    let type = "info";
                    let errorCodeHex;
                    if (typeof errorCode == 'number') {
                        errorCodeHex = errorCode.toString(16);
                        while (errorCodeHex.length < 8) {
                            errorCodeHex = '0' + errorCodeHex;
                        }
                    }
                    let message = SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, SalesToolkit.Translation.get('notificationContactSearchFailure', 'Could not get contacts informataion'));
                    if (SalesToolkit.Theme.getBooleanProperty("includeErrorCodeForContactSearch", true)) {
                        message += " - " + errorCode;
                    }

                    SalesToolkit.UI.Notifications.showCustomNotification(type, message, title);
                }
            });
            return;
        }

        if (contacts.length == 0)
            return;

        let atheneumContactOnly = contacts.filter(x => x instanceof Atheneum.Contact);
        if (atheneumContactOnly.length > 0)
            contacts = atheneumContactOnly;

        currentContactFilters = contacts;

        $('#contactFilterModal').modal('show');
        let step = 0;
        if (contacts.length > 5 && contacts.length < 10)
            step = 1;
        else if (contacts.length <= 5)
            step = 2;
        _setupContactFilterModalForContacts(contacts, step);
    }

    function _filterContactModalFilter(property, value, step, undef) {
        if (typeof currentFilteredContactFilters !== 'object' || !Array.isArray(currentFilteredContactFilters)) {
            let notificationBody = SalesToolkit.Translation.get('notificationContactFilterErrorFilters', 'Error: Could not find contact list to filter');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
        }

        let contacts = currentFilteredContactFilters;
        if (undef) {
            contacts = contacts.filter(x => !x.info.hasOwnProperty(property));
        } else {
            contacts = contacts.filter(x => (x.info[property] || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }

        //Skip to last step if contacts is 5 or under already
        if (step == 0 && contacts.length <= 5)
            step = 1;

        _setupContactFilterModalForContacts(contacts, (step + 1))
    }

    function _setupContactFilterModalForSearching() {
        $('#contactFilterOptions').empty();
        $('#contactFilterOptions').append('<span>' + SalesToolkit.Translation.getOrGetThemeKey('searchingExternalContactsMessage', 'Searching external contacts please wait...') + '</span>')
        $('#restartButton').hide();
    }

    function _setupContactFilterModalForContacts(contacts, step) {
        if (contacts.length == 1) {
            currentFilteredContactFilters = null;

            if (!$('#basic').css('display') == 'block') {
                _openShareModal();
                $('#basic').modal('show');
            }

            populateFormWithContact($('#salestoolkit-email-addresses-div'), contacts[0]);
            populateFormWithContact($('#salestoolkit-form-fields-div'), contacts[0]);
            let notificationBody = SalesToolkit.Translation.get('notificationContactFilterModalMatch', 'Contact loaded from filters');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            $('#contactFilterOptions').empty();
            $('#contactFilterModal').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            return;
        }

        let property = SalesToolkit.Theme.getStringProperty('contactFilteringFirstStep', 'country');

        if (step == 1) {
            property = SalesToolkit.Theme.getStringProperty('contactFilteringSecondStep', 'city');
        } else if (step >= 2) {
            property = SalesToolkit.Theme.getStringProperty('contactFilteringLastStep', 'email');
        }

        $('#contactFilterOptions').empty();

        try {
            let propertyMap = [...new Set(contacts.map(x => x.info[property]))];

            if (propertyMap.length == 0) {
                if (step >= 2) {
                    currentFilteredContactFilters = null;
                    let notificationBody = SalesToolkit.Translation.get('notificationContactFilterError', 'Something has gone wrong and could not load the filters.');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    return;
                }
                _setupContactFilterModalForContacts(contacts, (step + 1));
                return;
            }

            let formType = $('#salestoolkit-form-fields-div').data('form-type');
            let form = _getFormByType(formType);

            propertyMap.sort();
            let i;
            currentFilteredContactFilters = contacts;
            for (i = 0; i < propertyMap.length; i++) {
                let entry = propertyMap[i];
                let und = 'false';
                if (entry == undefined) {
                    entry = SalesToolkit.Translation.get('contactFilterNoInfo', 'Unknown');
                    und = 'true';
                }

                let entryLabel = entry;

                if (form && form.fields.find(x => x.name === property)?.type === 'SELECT') {
                    let options = form.fields.find(x => x.name === property).options;
                    let option = options.find(x => x.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() === entry.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
                    if (option) {
                        entryLabel = option.label;
                    }

                } else if (property === 'country' && typeof countries !== 'undefined') {
                    let useNativeNames = SalesToolkit.Theme.getBooleanProperty('useNativeCountryNames', true);
                    if (countries.hasOwnProperty(entry)) {
                        let country = countries[entry];
                        let countryName = (useNativeNames) ? country.native : country.name;

                        if (countryName) {
                            entryLabel = countryName;
                        }
                    }
                }

                $('#contactFilterOptions').append('<div class="contactFilterOption" onclick="filterContactModalFilter(\'' + property + '\', \'' + entry + '\', ' + step + ', ' + und + ')"><span>' + entryLabel + '</span></div>')
            }
        } catch (err) {
            console.log(err);
            _setupContactFilterModalForContacts(contacts, (step + 1));
        }
    }

    function _filtersStartOver() {
        atheneumGL.filtersStartOver();
    }

    function _clearFormFields() {
        clearForm($('#salestoolkit-form-fields-div'));
    }

    function _anySimilarEmails(emails, contactEmail) {
        if (typeof contactEmail === 'undefined')
            return false;

        if (emails.length == 0)
            return false;

        let i;
        let minimumSimilarity = SalesToolkit.Theme.getFloatProperty('minimumSimilarity', 1);

        for (i = 0; i < emails.length; i++) {
            let email = emails[i].address;
            if (_similarity(email, contactEmail) >= minimumSimilarity) // CORRECTED
                return true;
        }

        return false;
    }

    function _anyMatchingPhones(phones, contactPhone) {
        if (typeof contactPhone === 'undefined')
            return false;

        if (phones.length == 0)
            return false;

        let i;

        contactPhone = contactPhone.replace(/[^\d]/g, '');

        for (i = 0; i < phones.length; i++) {
            let phone = phones[i].number;
            phone = phone.replace(/[^\d]/g, '');
            if (phone == contactPhone)
                return true;
        }

        return false;
    }

    function _openedCartModal() {
        event.preventDefault();
        trackAppClick($('#salestoolkit-empty-cart'), '#salestoolkit-empty-cart', 'trackingCartClearModal', SalesToolkit.Translation.get('trackingCartClearModal', 'trackingCartClearModal'));
        return false;
    }

    function _similarity(s1, s2) {
        if (typeof s1 !== 'string')
            return false;
        if (typeof s2 !== 'string')
            return false;

        let longer = s1;
        let shorter = s2;
        if (s1.length < s2.length) {
            longer = s2;
            shorter = s1;
        }
        let longerLength = longer.length;
        if (longerLength == 0) {
            return 1.0;
        }
        return (longerLength - _editDistance(longer, shorter)) / parseFloat(longerLength);
    }

    function _editDistance(s1, s2) {
        s1 = s1.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        s2 = s2.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

        let costs = new Array();
        for (let i = 0; i <= s1.length; i++) {
            let lastValue = i;
            for (let j = 0; j <= s2.length; j++) {
                if (i == 0)
                    costs[j] = j;
                else {
                    if (j > 0) {
                        let newValue = costs[j - 1];
                        if (s1.charAt(i - 1) != s2.charAt(j - 1))
                            newValue = Math.min(Math.min(newValue, lastValue),
                                costs[j]) + 1;
                        costs[j - 1] = lastValue;
                        lastValue = newValue;
                    }
                }
            }
            if (i > 0)
                costs[s2.length] = lastValue;
        }
        return costs[s2.length];
    }

    async function _globalLookupCallback(message) {
        console.log(JSON.stringify(message));
        if (message.status == "suggestions") {
            let $field = $('#salestoolkit-form-fields-div').find("input[data-type='EMAIL']");
            await showContactSuggestions($field, message.contacts);
        } else if (message.status == "setupForNoContacts" && message.hasOwnProperty('fromScan')) {
            if (populatedFromCard) {
                let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilled', 'Share form information updated');
                SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
                _stopCamera();
                $('#cameraModal').modal('hide');

                return;
            } else if (!autoScan) {
                let notificationBody = SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan');
                SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
                return;
            } else if (SalesToolkit.Theme.getBooleanProperty('keepScanningOnContactFailureForm', false)) {
                $('#scan-info').text(SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan'));
                $('#scan-info').css('display', 'block');
                setTimeout(_takeScan, SalesToolkit.Theme.getIntegerProperty('timeBetweenAutoscans', 100), true);
            } else {
                let notificationBody = SalesToolkit.Translation.get('notificationCardReaderNoMatch', 'No existing contact could be found to match the scan');
                SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
                _stopCamera();
                $('#cameraModal').modal('hide');
                return;
            }
        } else if (message.status == "cameraStop") {
            _stopCamera();
            $('#cameraModal').modal('hide');
        } else if (message.status == 'setupForContacts') {
            $('#contactFilterModal').modal('show');
        } else if (message.status == "populateForm" && message.hasOwnProperty("fromScan")) {
            _stopCamera();
            $('#cameraModal').modal('hide');
            if (populatedFromCard) {
                let notificationBody = SalesToolkit.Translation.get('notificationCardReaderShareFilledBoth', 'Share form information updated from scan and matching contact');
                SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
                return;
            }

            let notificationBody = SalesToolkit.Translation.get('notificationCardReaderMatch', 'Contact loaded from scan');
            SalesToolkit.UI.Notifications.showCustomNotification("info", notificationBody);
        }
    }
    //#endregion

    //#region Email Form Management
    /**
     * Validates an email address string.
     * @param {string} value - The email string to validate.
     * @returns {boolean} - True if the email is valid, false otherwise.
     */
    const _valEmail = function (value) {
        let input = document.createElement('input');
        input.type = 'email';
        input.required = true;
        input.value = value;
        return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(value);
    }

    /**
     * Handles logic after a delay when an email input changes.
     * @param {HTMLElement} input - The email input element.
     * @param {boolean} fromContactSelect - Whether the change was triggered from a contact selection.
     */
    async function _emailInputChangedAfterDelay(input, fromContactSelect) {
        let formType = $('#salestoolkit-form-fields-div').data('form-type');

        if ((formType == 'shareCart' && !SalesToolkit.Theme.getBooleanProperty('createLinkOnShareSavedCart', false)) || SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true)) {
            $('.salestoolkit-share-form-add-another-email').css('visibility', 'visible');
        }
        else {
            $('.salestoolkit-share-form-add-another-email').css('visibility', 'hidden');
            if (screen.width <= 700)
                $('.salestoolkit-share-form-add-another-email').parent().hide();
        }

        if (!fromContactSelect && _valEmail($(input).val())) {
            try {
                let contact = await SalesToolkit.Contacts.getByEmailAddress($(input).val(), { 'exact': true });

                if (contact && contact.length > 0 && contact[0].id) {
                    contact = contact[0];
                    if (!(contact instanceof Atheneum.Contact)) {
                        contact = new Atheneum.Contact(contact);
                    }
                    let $htmlForm = $('#salestoolkit-form-fields-div');
                    onFormContactSelect($htmlForm, contact, $(input));
                }

            } catch (err) {
                console.log(err);
            }
        }
        let $inputs = $('input.salestoolkit-email-address');
        for (let i = 0; i < $inputs.length; i++) {
            let $input = $($inputs[i]);
            if ($input.val() == null || $input.val().trim().length == 0 || !_valEmail($input.val())) {
                $('.salestoolkit-share-form-add-another-email').css('visibility', 'hidden');
                break;
            }
        }
    }

    /**
     * Triggers the email changed logic after a debounce timeout.
     * @param {HTMLElement} input - The email input element.
     * @param {boolean} fromContactSelect - Whether the change was triggered from a contact selection.
     */
    function _emailInputChanged(input, fromContactSelect) {
        if (emailInputTimeout) {
            window.clearTimeout(emailInputTimeout);
        }
        const executeEmailInputDelayInMilliseconds = atheneumInstance.Theme.getIntegerProperty('delayOnSuggestionsTyping', 400);
        emailInputTimeout = window.setTimeout(_emailInputChangedAfterDelay, executeEmailInputDelayInMilliseconds, input, fromContactSelect);
    }

    /**
     * Adds a new email address input field to the share form.
     * @param {HTMLElement} triggerElement - The element that triggered the add action.
     */
    function _salestoolkitShareFormAddEmailAddressAfter(triggerElement) {
        let emailAddressGroup = $(triggerElement).closest('.salestoolkit-email-address-group')[0];

        let container = document.getElementById('salestoolkit-email-addresses-div');

        if (emailAddressGroup == document || emailAddressGroup.parentNode != container)
            return;

        let newEmailAddressGroup = document.createElement("DIV");
        container.insertAfter(newEmailAddressGroup, emailAddressGroup);
        newEmailAddressGroup.className = "input-group sendpadding salestoolkit-email-address-group";
        newEmailAddressGroup.style.marginTop = "10px";

        let placeHolder = SalesToolkit.Translation.getOrGetThemeKey('exampleEmailPlaceholder', 'name@example.com')

        $('.salestoolkit-share-form-add-another-email').css('visibility', 'hidden');

        newEmailAddressGroup.innerHTML = ''
            + '<div class="col-md-11 input-group margin-top-5" style="width:100%;">'
            + '<span onclick="getContactForButton(this);" class="contact-button-background input-group-addon"><i class="contact-button-foreground fa fa-envelope"></i></span>'
            // CORRECTED: Removed inline onkeyup/onpaste
            + '<input data-type="EMAIL" name="to" type="email" class="form-control salestoolkit-email-address cart-email-input"'
            + ' placeholder="' + placeHolder + '"'
            + ' data-translation-target="placeholder" data-translation-key="exampleEmailPlaceholder" data-translation-default="' + placeHolder + '" data-translation-rendered="true">'
            + '</div>'
            + '<span class="input-group-btn">'
            // CORRECTED: Added classes for delegated listeners
            + '<a href="javascript:;" class="btn btn-circle btn-icon-only btn-default salestoolkit-share-form-remove-email cart-remove-email"><i class="fa fa-close"></i></a>'
            + '<a href="javascript:;" class="btn btn-circle btn-icon-only btn-default salestoolkit-share-form-add-another-email cart-add-email" style="visibility:hidden; margin-left: 0px;"><i class="fa fa-plus"></i></a>'
            + '</span>'
            ;

        let $field = $(newEmailAddressGroup).find('input[data-type="EMAIL"]');
        if ($field.length > 0) {
            addContactSuggestionsToFormField($('#salestoolkit-form-fields-div'), $field.first());
        }

        let $inputs = $('input.salestoolkit-email-address');

        if (singleEmailMode && $inputs.length >= 2) {
            $('#salestoolkit-sharelink').hide();
        }
    }

    /**
     * Removes an email address input field from the share form.
     * @param {HTMLElement} triggerElement - The element that triggered the remove action.
     */
    function _salestoolkitShareFormRemoveEmailAddressAfter(triggerElement) {
        let emailAddressGroup = $(triggerElement).closest('.salestoolkit-email-address-group')[0];

        let container = document.getElementById('salestoolkit-email-addresses-div');

        if (emailAddressGroup == document || emailAddressGroup.parentNode != container)
            return;

        let emailIndex = $(emailAddressGroup).index();

        $('input[name="CONTACT_ID_' + emailIndex + '"]').remove()

        emailIndex++;
        //Reduce the contact index for each of the following email address inputs
        while ($('input[name="CONTACT_ID_' + emailIndex + '"]').length > 0) {
            $('input[name="CONTACT_ID_' + emailIndex + '"]').attr('name', 'CONTACT_ID_' + (emailIndex - 1))
        }

        container.removeChild(emailAddressGroup);

        $('.salestoolkit-share-form-add-another-email').css('visibility', 'visible');

        let $inputs = $('input.salestoolkit-email-address');
        for (let i = 0; i < $inputs.length; i++) {
            let $input = $($inputs[i]);
            if ($input.val() == null || $input.val().trim().length == 0 || !_valEmail($input.val())) {
                $('.salestoolkit-share-form-add-another-email').css('visibility', 'hidden');
                break;
            }
        }

        if (singleEmailMode && $inputs.length <= 1) {
            $('#salestoolkit-sharelink').show()
        }
    }
    //#endregion

    //#region Cart Event Handlers
    /**
     * Handles the confirmation click to empty the cart.
     */
    function _handleEmptyCartConfirm() {
        let itemsBefore = SalesToolkit.Cart.getTotalItems();

        SalesToolkit.Cart.empty(function (success, message) {
            salestoolkitUICart.removeAllItems();
            SalesToolkit.UI.Cart.updateMenuCartBadge();

            trackAppClick($('#cartModal .btn-primary'), '#cartModal .btn-primary', 'trackingCartClear', SalesToolkit.Translation.get('trackingCartClear', 'trackingCartClear'));

            if (itemsBefore != 0) {
                let notificationBody = SalesToolkit.Translation.get('notificationCartRemovedAll', 'Removed all items from Cart');
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            }

            _disableButtonsIfCartEmpty();
            _loadCartPanel();
        });
    }

    /**
     * Updates UI elements when an item is added or removed from the cart.
     */
    function _onCartItemChange() {
        SalesToolkit.UI.Cart.updateMenuCartBadge();
        _disableButtonsIfCartEmpty();
    }
    //#endregion

    //#region Share Modal
    /**
     * Opens the share modal with different configurations based on the action type.
     * @param {string} type - The type of share action ('share', 'registerInterest', 'mlr', 'shareCart').
     * @param {Event} event - The triggering event object.
     * @param {string|null} cartId - The ID of a saved cart, if applicable.
     */
    function _openShareModal(type = 'share', event, cartId = null) {

        let errorMessageBox = document.getElementById("salestoolkit-share-email-error-message-invalid");
        errorMessageBox?.classList.toggle('display-hide', true);

        errorMessageBox = document.getElementById("salestoolkit-share-email-error-message");
        errorMessageBox?.classList.toggle('display-hide', true);


        $('#salestoolkit-do-share').show();
        $('.shareSavedCartNote').hide();
        $('.shareSavedCartName').hide();
        $('#salestoolkit-cart-save-share-error').hide();

        let scForm = getShareCartForm();

        if ((type != 'shareCart' || scForm) && !SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) && SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false)) {
            $('#emailAddressesLabel').hide();
            $('#salestoolkit-email-addresses-div').hide();
            $('#salestoolkit-form-fields-div').show();
            $('#basic .modal-dialog').css('width', "90vw");
            $('.shareSavedCartNote').hide();
            if (SalesToolkit.Theme.getBooleanProperty('formPopupFitContent', true)) {
                $('#basic .modal-dialog').css('width', "fit-content");
            }

            let cssPropertyName = "Desktop";
            if (screen.width <= 1024) {
                cssPropertyName = "Tablet";
                if (screen.width <= 720) {
                    cssPropertyName = "Mobile";
                }
            }

            if (SalesToolkit.Theme.getIntegerProperty('forcePopupWidth' + cssPropertyName, 0) > 0) {
                $('#basic .modal-dialog').css('width', SalesToolkit.Theme.getIntegerProperty('forcePopupWidth' + cssPropertyName, 0) + "vw");
            }

        } else if (type == 'shareCart') {
            $('#basic .modal-dialog').css('width', "40vw");
            $('#emailAddressesLabel').show();
            $('#salestoolkit-email-addresses-div').show();
            $('#salestoolkit-form-fields-div').hide();
        }

        if (type != 'shareCart' && SalesToolkit.Theme.getBooleanProperty('onlyAllowAutoSubmit', false) && typeof SalesToolkit.Forms.userDetails !== 'object') {
            let notificationBody = SalesToolkit.Translation.get('autoSubmitOnlyError', 'You may need to fill a form before sending out documents.');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);

            try {
                if (event) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                }
            } catch (err) {
                $('#basic').modal('hide');
                setTimeout(function () {
                    $('#basic').modal('hide');
                }, 0);
            }
            return false;
        }

        $('#salestoolkit-form-fields-div').empty();
        document.getElementById('salestoolkit-me-too-checkbox').checked = false;
        document.getElementById('salestoolkit-me-too-checkbox').parentNode.className = "";

        let placeHolder = SalesToolkit.Translation.getOrGetThemeKey('exampleEmailPlaceholder', 'name@example.com');

        if ((type == 'shareCart' && typeof scForm === 'undefined') || SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) || !SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false)) {
            document.getElementById('salestoolkit-email-addresses-div').innerHTML = ""
                + '<div class="input-group sendpadding salestoolkit-email-address-group" style="margin-top: 10px;">'
                + '<div class="col-md-11 input-group margin-top-5" style="width:100%;">'
                + '<span onclick="getContactForButton(this);" class="contact-button-background input-group-addon"><i class="contact-button-foreground fa fa-envelope"></i></span>'
                // CORRECTED: Removed inline oninput/onpaste, added class
                + '<input data-type="EMAIL" name="to" type="email" class="form-control salestoolkit-email-address cart-email-input" placeholder="'
                + placeHolder
                + '" '
                + 'data-translation-target="placeholder" data-translation-key="exampleEmailPlaceholder" data-translation-default="' + placeHolder + '" data-translation-rendered="true">'
                + '</div>'
                + '<span class="input-group-btn">'
                // CORRECTED: Added classes for delegated listeners
                + '<a href="javascript:;" class="btn btn-circle btn-icon-only btn-default salestoolkit-share-form-remove-email cart-remove-email" style="margin-right: 10px; margin-left: 0px; "><i class="fa fa-close"></i></a>'
                + '<a href="javascript:;" class="btn btn-circle btn-icon-only btn-default salestoolkit-share-form-add-another-email cart-add-email" style="margin-left: 0px;visibility:hidden; "><i class="fa fa-plus"></i></a>'
                + '</span>'
                + '</div>';
        }
        let $field = $('input[data-type="EMAIL"]');
        if ($field.length > 0) {
            addContactSuggestionsToFormField($('#salestoolkit-form-fields-div'), $field.first());
        }

        $('#salestoolkit-form-fields-div').data('form-type', type);

        if (SalesToolkit.Theme.getBooleanProperty("allowShareLinkInCart", true)) {
            $('#salestoolkit-sharelink').show();
            singleEmailMode = true;
        } else {
            singleEmailMode = false;
            $('#salestoolkit-sharelink').hide();
        }

        if (typeof window.populatedImage !== 'undefined')
            window.tempPopImage = window.populatedImage;

        if (type === 'registerInterest') {
            $('#salestoolkit-do-share span').html(SalesToolkit.Translation.get('shareButtonRegisterInterest', 'Register Interest'));
            $('#sendTitle').html(SalesToolkit.Translation.get('sendRegisterInterest', 'Register Interest'));
            let riForm = getRegisterInterestForm();
            if (riForm) {
                renderForm(riForm, false, true, $('#salestoolkit-form-fields-div'), !SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false));
                window.atheneumGL = new AtheneumGlobalLookup(riForm, $('#salestoolkit-form-fields-div'), $('#contactFilterModal'), globalLookupCallback);
            }
        } else if (type === 'mlr') {
            $('#salestoolkit-do-share span').html(SalesToolkit.Translation.get('shareButtonMLR', 'Approval Workflow'));
            $('#sendTitle').html(SalesToolkit.Translation.get('sendMLR', 'Approval Workflow'));
            let mlrForm = getMLRReviewForm();
            if (mlrForm) {
                renderForm(mlrForm, false, true, $('#salestoolkit-form-fields-div'), !SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false));
                window.atheneumGL = new AtheneumGlobalLookup(mlrForm, $('#salestoolkit-form-fields-div'), $('#contactFilterModal'), globalLookupCallback);
            }
        } else if (type == 'shareCart') {
            if (SalesToolkit.Theme.getBooleanProperty('allowShareLinkForSavedCartShare', false)) {
                $('#salestoolkit-sharelink').show();
            } else {
                $('#salestoolkit-sharelink').hide();
            }

            if (SalesToolkit.Theme.getBooleanProperty('allowRegularShareForSavedCartShare', true)) {
                $('#salestoolkit-do-share').show();
            } else {
                $('#salestoolkit-do-share').hide();
            }

            $('#salestoolkit-do-share span').html(SalesToolkit.Translation.get('saveAndShare', 'Save'));
            $('#sendTitle').html(SalesToolkit.Translation.get('shareSavedCart', 'Share Saved Cart'));
            $('#salestoolkit-form-fields-div').attr('cartId', cartId);
            $('#shareSavedCartNote').val('');
            $('#shareSavedCartNote').attr('maxlength', SalesToolkit.Theme.getIntegerProperty('savedCartsNoteMaxLength', 1024));
            if (!scForm)
                $('.shareSavedCartNote').show();
            if (!cartId && SalesToolkit.Theme.getBooleanProperty('shareAndSave', false)) {
                $('.shareSavedCartName').show();
            }

            if (scForm) {
                renderForm(scForm, false, true, $('#salestoolkit-form-fields-div'), false);
                window.atheneumGL = new AtheneumGlobalLookup(scForm, $('#salestoolkit-form-fields-div'), $('#contactFilterModal'), globalLookupCallback);

                setTimeout(function () {
                    $('#salestoolkit-form-fields-div').css('column-width', $('#form-body').width());
                    $('#salestoolkit-form-fields-div').css('padding-bottom', 0);
                }, 200);
            }
        } else {
            //Default to share
            $('#salestoolkit-do-share span').html(SalesToolkit.Translation.get('share', 'Share'));
            $('#sendTitle').html(SalesToolkit.Translation.get('sendAssets', 'Send Assets'));
            let shareForm = getCartShareForm();
            if (shareForm) {
                renderForm(shareForm, false, true, $('#salestoolkit-form-fields-div'), !SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false));
                window.atheneumGL = new AtheneumGlobalLookup(shareForm, $('#salestoolkit-form-fields-div'), $('#contactFilterModal'), globalLookupCallback);
            }
        }

        if (typeof window.tempPopImage !== 'undefined')
            window.populatedImage = window.tempPopImage;

        window.tempPopImage = undefined;

        if (type != 'shareCart' && SalesToolkit.Theme.getBooleanProperty('autoSendFromUserDetails', true) && typeof SalesToolkit.Forms.userDetails === 'object') {
            $('#salestoolkit-do-share').click();
        }
    }

    /**
     * Retrieves the correct form configuration object based on the type.
     * @param {string} type - The type of form to retrieve.
     * @returns {object|undefined} The form configuration object.
     */
    function _getFormByType(type) {
        if (type === 'registerInterest') {
            return getRegisterInterestForm();
        } else if (type === 'mlr') {
            return getMLRReviewForm();
        } else if (type === 'shareCart') {
            return getShareCartForm();
        } else {
            return getCartShareForm();
        }
    }

    /**
     * Shows or hides different platform sharing options in the share link popup.
     */
    function _updateCartShareOptions() {
        $('.whatsapp-btn').css('display', SalesToolkit.Theme.getBooleanProperty('sharePopupPlatfWhatsApp', false) ? '' : 'none');
        $('.wechat-btn').css('display', SalesToolkit.Theme.getBooleanProperty('sharePopupPlatfWeChat', false) ? '' : 'none');
        $('.qrCode').css('display', SalesToolkit.Theme.getBooleanProperty('sharePopupPlatfWeChat', false) || atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfQrCode', false) ? '' : 'none');
        $('.email-btn').css('display', SalesToolkit.Theme.getBooleanProperty('sharePopupPlatfEmail', false) ? '' : 'none');
        $('.sms-btn').css('display', SalesToolkit.Theme.getBooleanProperty('sharePopupPlatfSMS', false) ? '' : 'none');
    }
    //#endregion

    //#region Share and Submit Logic
    /**
     * Handles the primary share/submit button click event.
     * @param {Event} event - The click event object.
     */
    function _handleDoShareClick(event) {
        let formType = $('#salestoolkit-form-fields-div').data('form-type');

        document.getElementById('salestoolkit-empty-cart').classList.add('disabled');
        document.getElementById('salestoolkit-share-cart').classList.add('disabled');
        let re = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
        let emailAddresses = [];

        let scForm = getShareCartForm();

        let inputId = 'salestoolkit-email-addresses-div';
        if (formType != 'shareCart' && !SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) && SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false)) {
            inputId = 'salestoolkit-form-fields-div';
        }

        if (typeof scForm !== 'undefined') {
            inputId = 'salestoolkit-form-fields-div';
        }

        let invalidEmails = false;
        let inputElements = document.getElementById(inputId).querySelectorAll('input[type=email]');
        for (let i = 0; i < inputElements.length; i++) {
            if (inputElements[i].classList.contains('ignore'))
                continue;
            let address = inputElements[i].value;
            if ((typeof address === "string") && address.trim() != "") {
                if (re.test(address))
                    emailAddresses[emailAddresses.length] = address;
                else {
                    invalidEmails = true;
                }
            }
        }

        if (formType === 'share' && invalidEmails) {
            let errorMessageBox = document.getElementById("salestoolkit-share-email-error-message-invalid");
            errorMessageBox.classList.toggle('display-hide', false);
            event.stopPropagation();
            event.preventDefault();
            _disableButtonsIfCartEmpty();
            return false;
        }

        let intended = emailAddresses.length;

        const shareForm = getCartShareForm();
        const shouldRemoteComplete = formType === 'share' &&
            ((shareForm?.properties?.remoteCompletionRequired === 'true') ||
                (emailAddresses.length === 0 && shareForm?.properties?.remoteCompletionEnabled === 'true'));

        if (formType === 'share' && intended == 0 && !shouldRemoteComplete) {
            let errorMessageBox = document.getElementById("salestoolkit-share-email-error-message");
            errorMessageBox.classList.toggle('display-hide', false);
            event.stopPropagation();
            event.preventDefault();
            _disableButtonsIfCartEmpty();
            return false;
        }

        if (formType === 'shareCart') {
            if (validateForm($('#salestoolkit-form-fields-div'))) {
                getFormData($('#salestoolkit-form-fields-div'), function (fields) {
                    let data = {};
                    if (fields)
                        data.formData = fields;

                    data.recipients = emailAddresses;
                    let cartId = $('#salestoolkit-form-fields-div').attr('cartId');

                    if ($('#basic').css('display') == 'block') {
                        $('#basic').modal('hide');
                        setTimeout(function () {
                            $('#basic').modal('hide');
                        }, 0);
                    }

                    if (!cartId && SalesToolkit.Theme.getBooleanProperty('shareAndSave', false)) {
                        _trySaveAndShareCart(false, data, $('#shareSavedCartNote').val())
                    } else {
                        _shareSavedCartConfirm(emailAddresses, $('#shareSavedCartNote').val(), data.formData);
                    }
                });
            }
            event.stopPropagation();
            event.preventDefault();
            return false;
        }

        if (validateForm($('#salestoolkit-form-fields-div'))) {
            getFormData($('#salestoolkit-form-fields-div'), function (fields) {
                if (typeof fields === 'undefined')
                    fields = {};

                if (!fields.hasOwnProperty('language') || fields.language === '') {
                    let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
                    fields.language = userLanguage.iso_code;
                }
                let form = _getFormByType(formType);
                if (form && form.requireConsent) {
                    if ($('#salestoolkit-form-fields-div').parents('form').attr('data-contact-consented') !== 'true' &&
                        $('#salestoolkit-form-fields-div').attr('data-contact-consented') !== 'true') {
                        let notificationBody = SalesToolkit.Translation.get('error08071400', 'Consent is required to submit.');
                        SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                        _disableButtonsIfCartEmpty();
                        return;
                    }
                }
                let emailSubjectBox = document.getElementById('salestoolkit-custom-email-subject');
                if (emailSubjectBox != null && emailSubjectBox.value.trim())
                    fields['email_subject'] = emailSubjectBox.value;

                let emailBodyBox = document.getElementById('salestoolkit-custom-email-body');
                if (emailBodyBox != null && emailBodyBox.value.trim()) {
                    fields['email_body'] = emailBodyBox.value;
                }

                if (SalesToolkit.User.preferences.email)
                    fields['email_replyTo'] = SalesToolkit.User.preferences.email;

                if (document.getElementById('salestoolkit-me-too-checkbox').checked
                    && SalesToolkit.User.preferences.email
                    && !emailAddresses.includes(SalesToolkit.User.preferences.email)) {
                    emailAddresses[emailAddresses.length] = SalesToolkit.User.preferences.email;
                }

                let callbacks = {
                    success: function (nShared, json) {
                        let notificationBody = SalesToolkit.Translation.get('notificationCartShareSuccess', 'Cart contents sent successfully');
                        if (nShared >= intended) {
                            let cart = SalesToolkit.Cart.getLoadedCart();
                            if (typeof cart === 'undefined')
                                SalesToolkit.Cart.empty();
                            salestoolkitUICart.refresh();
                            SalesToolkit.UI.Cart.updateMenuCartBadge();
                            _loadCartPanel();
                            if (formType === 'registerInterest') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartRegisterInterestSuccess', 'Cart contents registered successfully');
                            } else if (formType === 'mlr') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartMLRSuccess', 'Cart contents sent successfully');
                            }
                            if (typeof SalesToolkit.Forms.userDetails === 'object' && SalesToolkit.Forms.userDetails.hasOwnProperty('hasConsentStatus') && !SalesToolkit.Forms.userDetails.hasConsentStatus) {
                                notificationBody = SalesToolkit.Translation.get('cartSentInSessionWithoutConsentStatus', notificationBody);
                            }
                            _disableButtonsIfCartEmpty();
                        }
                        else if (nShared > 0) {
                            notificationBody = SalesToolkit.Translation.getFormatted('notificationCartShareSuccessPartial', 'Cart contents sent to {0} of {1} recipients', [nShared, intended]);
                            if (formType === 'registerInterest') {
                                notificationBody = SalesToolkit.Translation.getFormatted('notificationCartRegisterInterestSuccessPartial', '{0} of {1} items registered', [nShared, intended]);
                            } else if (formType === 'mlr') {
                                notificationBody = SalesToolkit.Translation.getFormatted('notificationCartMLRSuccessPartial', '{0} of {1} items sent', [nShared, intended]);
                            }
                            _disableButtonsIfCartEmpty();
                        }
                        if ($('#basic').css('display') == 'block') {
                            $('#basic').modal('hide');
                            setTimeout(function () {
                                $('#basic').modal('hide');
                            }, 0);
                        }
                        let notificationsToShow = [];
                        if (SalesToolkit.Theme.getBooleanProperty('endSessionOnCartSubmit', false)) {
                            try {
                                SalesToolkit.Cart.assetIds = [];
                                SalesToolkit.Cart.collectionIds = [];
                                SalesToolkit.Cart.saveToStorage();
                                SalesToolkit.UI.Cart.updateMenuCartBadge();
                                SalesToolkit.Cart.empty(function () {
                                    SalesToolkit.UI.Cart.updateMenuCartBadge();
                                });
                            } catch (err) { }

                            if (SalesToolkit.Theme.getBooleanProperty('closeCartOnSubmit', false)) {
                                let message = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessMessage', "Prefill details removed");
                                let title = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessTitle', "Goodbye!");
                                notificationsToShow.push([{ body: message, title: title, type: "info" }]);
                            } else if (typeof SalesToolkit.Forms.userDetails === 'object') {
                                let message = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessMessage', "Prefill details removed");
                                let title = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessTitle', "Goodbye!");
                                SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
                            }
                            SalesToolkit.Forms.unloadUserDetails();
                            trackContactSessionEnd(SalesToolkit.Translation.get('sessionEndFromCartSubmission', 'sessionEndFromCartSubmission'));
                        }
                        if (SalesToolkit.Theme.getBooleanProperty('closeCartOnSubmit', false)) {
                            notificationsToShow.push([{ body: notificationBody, title: "", type: "cart" }]);
                            localStorage["notificationsToShow"] = JSON.stringify(notificationsToShow);
                            _disableButtonsIfCartEmpty();
                            if (SalesToolkit.Theme.getBooleanProperty('closeCartOnSubmitUsesBack', false)) {
                                _cartModuleGoBack()
                                return;
                            }
                            // UPDATED CODE BLOCK
                            if (typeof loadContent === 'function') {
                                const newUrl = 'index.html?loadHome=true';
                                window.history.replaceState({ path: newUrl }, '', newUrl);
                                loadContent('index');
                            } else {
                                console.error('loadContent function is not available. Falling back to page reload.');
                                window.location.href = "index.html?loadHome=true";
                            }
                            return;
                        }
                        SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                        _disableButtonsIfCartEmpty();
                    },
                    failure: function (reason, httpStatus, errorCode, functionName, json) {
                        let errorCodeHex = undefined;
                        if (typeof errorCode == 'number') {
                            errorCodeHex = errorCode.toString(16);
                            while (errorCodeHex.length < 8) {
                                errorCodeHex = '0' + errorCodeHex;
                            }
                        }
                        if (typeof json !== 'undefined' && json.hasOwnProperty('missingParams') && Array.isArray(json.missingParams) && json.missingParams.length > 0) {
                            let notificationBody = SalesToolkit.Translation.get('notificationCartShareFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                            if (formType === 'registerInterest') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartRegisterInterestFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be registered'));
                            } else if (formType === 'mlr') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartMLRFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                            }
                            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                            for (let i = 0; i < json.missingParams.length; i++) {
                                let name = json.missingParams[i];
                                let $field = $('[name="' + name + '"]');
                                if ($field.length == 0)
                                    continue;
                                let $label = $('label[for="' + name + '"]');
                                $field.addClass('invalid');
                                $label.addClass('invalid');
                                $field.addClass('invalid previously-invalid');
                                $label.addClass('invalid previously-invalid');
                            }
                            return;
                        }
                        if ($('#basic').css('display') == 'block') {
                            $('#basic').modal('hide');
                            setTimeout(function () {
                                $('#basic').modal('hide');
                            }, 0);
                        }
                        if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                            let cart = SalesToolkit.Cart.getLoadedCart();
                            if (typeof cart === 'undefined')
                                SalesToolkit.Cart.empty();
                            salestoolkitUICart.refresh();
                            SalesToolkit.UI.Cart.updateMenuCartBadge();
                            _loadCartPanel();
                            let notificationBody = SalesToolkit.Translation.getFormatted('notificationCartShareOffline', 'Cart contents will be sent when you are next online');
                            if (formType === 'registerInterest') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartRegisterInterestOffline', 'Cart contents will be registered when you are next online');
                            } else if (formType === 'mlr') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartMLROffline', 'Cart contents will be sent when you are next online');
                            }
                            if (SalesToolkit.Forms.userDetails === 'object' && SalesToolkit.Forms.userDetails.hasOwnProperty('hasConsentStatus') && !SalesToolkit.Forms.userDetails.hasConsentStatus) {
                                notificationBody = SalesToolkit.Translation.get('cartSentInSessionWithoutConsentStatus', notificationBody);
                            }
                            if ($('#basic').css('display') == 'block') {
                                $('#basic').modal('hide');
                                setTimeout(function () {
                                    $('#basic').modal('hide');
                                }, 0);
                            }
                            let notificationsToShow = [];
                            if (SalesToolkit.Theme.getBooleanProperty('endSessionOnCartSubmit', false)) {
                                try {
                                    SalesToolkit.Cart.assetIds = [];
                                    SalesToolkit.Cart.collectionIds = [];
                                    SalesToolkit.Cart.saveToStorage();
                                    SalesToolkit.UI.Cart.updateMenuCartBadge();
                                    SalesToolkit.Cart.empty(function () {
                                        SalesToolkit.UI.Cart.updateMenuCartBadge();
                                    });
                                } catch (err) { }
                                if (SalesToolkit.Theme.getBooleanProperty('closeCartOnSubmit', false)) {
                                    let message = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessMessage', "Prefill details removed");
                                    let title = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessTitle', "Goodbye!");
                                    notificationsToShow.push([{ body: message, title: title, type: "info" }]);
                                } else if (typeof SalesToolkit.Forms.userDetails === 'object') {
                                    let message = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessMessage', "Prefill details removed");
                                    let title = SalesToolkit.Translation.get('prefillUnloadFromCartQRSuccessTitle', "Goodbye!");
                                    SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
                                }
                                SalesToolkit.Forms.unloadUserDetails();
                                trackContactSessionEnd(SalesToolkit.Translation.get('sessionEndFromCartOfflineSubmission', 'sessionEndFromCartOfflineSubmission'));
                            }
                            if (SalesToolkit.Theme.getBooleanProperty('closeCartOnSubmit', false)) {
                                notificationsToShow.push([{ body: notificationBody, title: "", type: "cart" }]);
                                localStorage["notificationsToShow"] = JSON.stringify(notificationsToShow);
                                _disableButtonsIfCartEmpty();
                                // UPDATED CODE BLOCK
                                if (typeof loadContent === 'function') {
                                    const newUrl = 'index.html?loadHome=true';
                                    window.history.replaceState({ path: newUrl }, '', newUrl);
                                    loadContent('index');
                                } else {
                                    console.error('loadContent function is not available. Falling back to page reload.');
                                    window.location.href = "index.html?loadHome=true";
                                }
                                return;
                            }
                            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                            _disableButtonsIfCartEmpty();
                        } else if (errorCodeHex == '08071400') {
                            let notificationBody = SalesToolkit.Translation.get('error08071400', 'Consent is required to submit.');
                            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                            _disableButtonsIfCartEmpty();
                        } else {
                            let notificationBody = SalesToolkit.Translation.get('notificationCartShareFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                            if (formType === 'registerInterest') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartRegisterInterestFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be registered'));
                            } else if (formType === 'mlr') {
                                notificationBody = SalesToolkit.Translation.get('notificationCartMLRFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                            }
                            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                            _disableButtonsIfCartEmpty();
                        }
                    }
                };

                if (typeof window.formHistoryId === 'string' && form.allowSubmissionUpdates)
                    fields.linkedSubmissionId = window.formHistoryId;
                if (typeof window.populatedImage !== 'undefined' && form.storeScannedImages) {
                    fields.linkedScanImage = window.populatedImage;
                }
                event.stopPropagation();
                event.preventDefault();

                let shareInfo = {};
                shareInfo.fields = fields;
                shareInfo.emails = emailAddresses;

                if (formType === 'registerInterest') {
                    trackAppClick($('#salestoolkit-do-share'), '#salestoolkit-do-share', 'trackingCartDoRegisterInterest', SalesToolkit.Translation.get('trackingCartDoRegisterInterest', 'trackingCartDoRegisterInterest'), shareInfo);
                    SalesToolkit.Cart.registerInterest(emailAddresses, fields, callbacks);
                } else if (formType === 'mlr') {
                    trackAppClick($('#salestoolkit-do-share'), '#salestoolkit-do-share', 'trackingCartDoMLRReview', SalesToolkit.Translation.get('trackingCartDoMLRReview', 'trackingCartDoMLRReview'), shareInfo);
                    SalesToolkit.Cart.mlrReview(emailAddresses, fields, callbacks);
                } else {
                    trackAppClick($('#salestoolkit-do-share'), '#salestoolkit-do-share', 'trackingCartDoShare', SalesToolkit.Translation.get('trackingCartDoShare', 'trackingCartDoShare'), shareInfo);

                    if (shouldRemoteComplete) {
                        SalesToolkit.Cart.shareRemoteCompletion(shareForm, fields, {
                            success: function (json) {


                                const colorHexDark = SalesToolkit.Theme.getColourProperty("externalQRCodeDarkHex", "#000000");
                                const colorHexLight = SalesToolkit.Theme.getColourProperty("externalQRCodeLightHex", "#ffffff")

                                const errorCorrection = SalesToolkit.Theme.getStringProperty("externalQRCodeErrorCorrectionLevel", "M")

                                const formQRCode = new QRCode(document.getElementById("formQRCode"), {
                                    text: json.link,
                                    width: SalesToolkit.Theme.getIntegerProperty('externalQRCodeWidth', 512),
                                    height: SalesToolkit.Theme.getIntegerProperty('externalQRCodeHeight', 512),
                                    colorDark: colourString(colorHexDark),
                                    colorLight: colourString(colorHexLight),
                                    correctLevel: QRCode.CorrectLevel[errorCorrection]
                                });

                                const showButton = SalesToolkit.Theme.getBooleanProperty('showRemoteCompletionCloseButton', true);
                            $('#qrCodeModal button').toggle(showButton);
                            
                                let notificationBody = SalesToolkit.Translation.get('notificationCartShareRemoteCompletionSuccess', 'Cart contents sent successfully');
                                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                                salesToolkitDisableButtonsIfNothingInCart();
                                if ($('#basic').css('display') == 'block') {
                                    $('#basic').modal('hide');
                                    setTimeout(function () {
                                        $('#basic').modal('hide');
                                        $('#qrCodeModal').modal('show');
                                        _startRemoteCompletion(json.id);
                                    }, 0);
                                }
                            },

                            failure: function (reason, httpStatus, errorCode, functionName, json) {

                                var errorCodeHex = undefined;
                                if (typeof errorCode == 'number') {
                                    errorCodeHex = errorCode.toString(16);
                                    while (errorCodeHex.length < 8) {
                                        errorCodeHex = '0' + errorCodeHex;
                                    }
                                }

                                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                                    var notificationBody = SalesToolkit.Translation.getFormatted('notificationCartRemoteCompletionShareOffline', 'Remote completion can only be completed while online. Please check your connection and try again.');
                                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                                    salesToolkitDisableButtonsIfNothingInCart();
                                    if ($('#basic').css('display') == 'block') {
                                        $('#basic').modal('hide');
                                        setTimeout(function () {
                                            $('#basic').modal('hide');
                                        }, 0);
                                    }
                                }
                                else {
                                    var notificationBody = SalesToolkit.Translation.get('notificationCartRemoteShareFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Remote completion could not be completed.'));
                                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                                    salesToolkitDisableButtonsIfNothingInCart();
                                }
                            }
                        });
                    } else {
                        SalesToolkit.Cart.share(emailAddresses, fields, callbacks);
                    }
                }
            });
        } else {
            //Validation failed
            let notificationBody = SalesToolkit.Translation.get('notificationCartShareValidationFailure', 'Please fill in all required fields');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            _disableButtonsIfCartEmpty();
            event.stopPropagation();
            event.preventDefault();
            _disableButtonsIfCartEmpty();
            return false;
        }
    }


    /**
     * Handles the share link button click event.
     * @param {Event} event - The click event object.
     */
    function _handleShareLinkClick(event) {
        let formType = $('#salestoolkit-form-fields-div').data('form-type');
        document.getElementById('salestoolkit-empty-cart').classList.add('disabled');
        document.getElementById('salestoolkit-share-cart').classList.add('disabled');
        let re = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
        let emailAddresses = [];
        let inputId = 'salestoolkit-email-addresses-div';
        if (formType == 'shareCart' || (!SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) && SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false))) {
            inputId = 'salestoolkit-form-fields-div';
        }

        let invalidEmails = false;
        let inputElements = document.getElementById(inputId).querySelectorAll('input[type=email]');
        for (let i = 0; i < inputElements.length; i++) {
            if (inputElements[i].classList.contains('ignore'))
                continue;
            let address = inputElements[i].value;
            if ((typeof address === "string") && address.trim() != "") {
                if (re.test(address))
                    emailAddresses[emailAddresses.length] = address;
                else {
                    invalidEmails = true;
                }
            }
        }
        trackAppClick($('#salestoolkit-sharelink'), '#salestoolkit-sharelink', 'trackingCartShareLink', SalesToolkit.Translation.get('trackingCartShareLink', 'trackingCartShareLink'));
        let intended = emailAddresses.length;
        if (formType === 'share' && intended == 0) {
            let errorMessageBox = document.getElementById("salestoolkit-share-email-error-message");
            errorMessageBox.classList.toggle('display-hide', false);
            event.stopPropagation();
            event.preventDefault();
            _disableButtonsIfCartEmpty();
            return false;
        }
        if (formType === 'shareCart') {
            if (validateForm($('#salestoolkit-form-fields-div'))) {
                getFormData($('#salestoolkit-form-fields-div'), function (fields) {
                    let data = {};
                    if (fields)
                        data.formData = fields;
                    data.recipients = emailAddresses;
                    let cartId = $('#salestoolkit-form-fields-div').attr('cartId');
                    if (!cartId && SalesToolkit.Theme.getBooleanProperty('shareAndSave', false)) {
                        _trySaveAndShareCart(false, data, $('#shareSavedCartNote').val(), true)
                    } else {
                        _shareSavedCartConfirm(emailAddresses, $('#shareSavedCartNote').val(), data.formData, true);
                    }
                });
            }
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        let callbacks = {
            success: function (nShared) {
                let cart = SalesToolkit.Cart.getLoadedCart();
                if (typeof cart === 'undefined')
                    SalesToolkit.Cart.empty();
                salestoolkitUICart.refresh();
                SalesToolkit.UI.Cart.updateMenuCartBadge();
                _loadCartPanel();
                let notificationBody = SalesToolkit.Translation.get('notificationCartShareSuccess', 'Cart contents sent successfully');
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                _disableButtonsIfCartEmpty();
                if ($('#basic').css('display') == 'block') {
                    $('#basic').modal('hide');
                    setTimeout(function () {
                        $('#basic').modal('hide');
                    }, 0);
                }
            },
            failure: function (reason, httpStatus, errorCode, functionName, json) {
                let errorCodeHex;
                if (typeof errorCode == 'number') {
                    errorCodeHex = errorCode.toString(16);
                    while (errorCodeHex.length < 8) {
                        errorCodeHex = '0' + errorCodeHex;
                    }
                }

                if (typeof json !== 'undefined' && json.hasOwnProperty('missingParams') && Array.isArray(json.missingParams) && json.missingParams.length > 0) {
                    let notificationBody = SalesToolkit.Translation.get('notificationCartShareFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    for (let i = 0; i < json.missingParams.length; i++) {
                        let name = json.missingParams[i];
                        let $field = $('[name="' + name + '"]');
                        if ($field.length == 0)
                            continue;
                        let $label = $('label[for="' + name + '"]');
                        $field.addClass('invalid');
                        $label.addClass('invalid');
                        $field.addClass('invalid previously-invalid');
                        $label.addClass('invalid previously-invalid');
                    }
                    return;
                }
                if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
                    let cart = SalesToolkit.Cart.getLoadedCart();
                    if (typeof cart === 'undefined')
                        SalesToolkit.Cart.empty();
                    salestoolkitUICart.refresh();
                    SalesToolkit.UI.Cart.updateMenuCartBadge();
                    _loadCartPanel();
                    let notificationBody = SalesToolkit.Translation.getFormatted('notificationCartShareOffline', 'Cart contents will be sent when you are next online');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    _disableButtonsIfCartEmpty();
                    if ($('#basic').css('display') == 'block') {
                        $('#basic').modal('hide');
                        setTimeout(function () {
                            $('#basic').modal('hide');
                        }, 0);
                    }
                }
                else {
                    let notificationBody = SalesToolkit.Translation.get('notificationCartShareFailure', SalesToolkit.Translation.getOrGetThemeKey('error' + errorCodeHex, 'Cart contents could not be sent'));
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    _disableButtonsIfCartEmpty();
                }
            }
        }
        let shareForm = getCartShareForm();
        if (validateForm($('#salestoolkit-form-fields-div'))) {
            if (shareForm) {
                let inputId = 'salestoolkit-email-addresses-div';
                if (formType != 'shareCart' && !SalesToolkit.Theme.getBooleanProperty('allowMultipleEmailsInCart', true) && SalesToolkit.Theme.getBooleanProperty('useShareFormEmail', false)) {
                    inputId = 'salestoolkit-form-fields-div';
                }
                shareLinkSubmit(shareForm, $('#' + inputId), callbacks, $('#salestoolkit-form-fields-div'));
            }
            else {
                let notificationBody = SalesToolkit.Translation.get('notificationCartShareNoForm', 'No share form found, a form must be setup if using share links');
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                _disableButtonsIfCartEmpty();
            }
        } else {
            //Validation failed
            let notificationBody = SalesToolkit.Translation.get('notificationCartShareValidationFailure', 'Please fill in all required fields');
            SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            _disableButtonsIfCartEmpty();
            event.stopPropagation();
            event.preventDefault();
            _disableButtonsIfCartEmpty();
            return false;
        }
    }
    //#endregion

    //#region Cart Saving
    /**
     * Confirms and sends a request to share a saved cart.
     * @param {string[]} emailAddresses - Array of recipient email addresses.
     * @param {string} note - A note to include with the share.
     * @param {object} [formData] - Optional form data to include.
     * @param {boolean} [useShareLink=false] - Whether to generate a shareable link.
     */
    function _shareSavedCartConfirm(emailAddresses, note, formData = undefined, useShareLink = false) {
        let cartId = $('#salestoolkit-form-fields-div').attr('cartId');
        let finished = function (success, message) {
            if (SalesToolkit.Theme.getBooleanProperty('updateContactsOnCartShare', false)) {
                setTimeout(function () {
                    SalesToolkit.Contacts.update();
                }, 1000);
            }
            if (success) {
                if (SalesToolkit.Theme.getBooleanProperty('showCartSharedSuccessNotification', true)) {
                    let notificationBody = SalesToolkit.Translation.get('cartShareSuccess', 'Cart shared');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                }
                if (message && message.hasOwnProperty('link') && SalesToolkit.Theme.getBooleanProperty('createLinkOnShareSavedCart', false)) {
                    _updateCartShareOptions();
                    let json = {};
                    json.link = message.link;
                    let whatsAppLink = 'https://web.whatsapp.com/send?text=';
                    if (supportsWhatsApp()) {
                        whatsAppLink = 'whatsapp://send?text=';
                    }
                    let shareLinkPopupEmailSubject = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailSubject', '');
                    $('#whatsapp-link').attr('href', whatsAppLink + encodeURI(json.link));
                    $('#downloadInput').val(json.link);
                    $('.qrCode img').attr('src', 'https://trustrack.atheneum.co/dms/public/barcode.png?type=QR_CODE&width=230&height=230&margin=0&content=' + encodeURI(json.link));
                    let shareLinkPopupEmailBody = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailBody', '{link}');
                    if (shareLinkPopupEmailBody.indexOf('{link}') != -1) {
                        shareLinkPopupEmailBody = shareLinkPopupEmailBody.replace('{link}', encodeURI(json.link));
                    }
                    $('#sms-link').attr('href', 'sms:?&body=' + shareLinkPopupEmailBody);
                    let email = emailAddresses ? emailAddresses.toString() : '';
                    if (shareLinkPopupEmailSubject === '')
                        $('#email-link').attr('href', 'mailto:' + email + '?body=' + shareLinkPopupEmailBody);
                    else
                        $('#email-link').attr('href', 'mailto:' + email + '?subject=' + shareLinkPopupEmailSubject + '&body=' + shareLinkPopupEmailBody);
                    if ($('#basic').css('display') == 'block') {
                        $('#basic').modal('hide');
                        setTimeout(function () {
                            $('#basic').modal('hide');
                        }, 0);
                    }
                    $('#shareLinkPopup').modal('show');
                }
            } else {
                let notificationBody = message;
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
            }
        };
        SalesToolkit.Cart.shareSavedCart(cartId, emailAddresses, note, finished, formData, useShareLink);
    }

    /**
     * Formats a date object into a user-friendly string.
     * @param {Date} date - The date to format.
     * @returns {string} The formatted date string.
     */
    function _dateToNiceString(date) {
        let day = date.getDate();
        let year = date.getFullYear();
        let month = [
            SalesToolkit.Translation.get("jan", "Jan"), SalesToolkit.Translation.get("feb", "Feb"),
            SalesToolkit.Translation.get("mar", "Mar"), SalesToolkit.Translation.get("apr", "Apr"),
            SalesToolkit.Translation.get("may", "May"), SalesToolkit.Translation.get("jun", "Jun"),
            SalesToolkit.Translation.get("jul", "Jul"), SalesToolkit.Translation.get("aug", "Aug"),
            SalesToolkit.Translation.get("sep", "Sep"), SalesToolkit.Translation.get("oct", "Oct"),
            SalesToolkit.Translation.get("nov", "Nov"), SalesToolkit.Translation.get("dec", "Dec"),
        ][date.getMonth()];

        if (SalesToolkit.Theme.getBooleanProperty('useNumberDateOnlyForDefaultSavedCartsName', true)) {
            day = (day < 10) ? "0" + day : "" + day;
            let dateMonth = date.getMonth() + 1;
            dateMonth = (dateMonth < 10) ? "0" + dateMonth : "" + dateMonth;
            if (SalesToolkit.Theme.getBooleanProperty('monthFirstForDefaultDate', false)) {
                return dateMonth + "/" + day + "/" + year;
            }
            return day + "/" + dateMonth + "/" + year;
        }
        return day + " " + month + " " + year;
    }

    /**
     * Opens the modal for saving the current cart.
     */
    function _openCartSaveModal() {
        trackAppClick($('#salestoolkit-save-cart'), '#salestoolkit-save-cart', 'trackingSaveCart', SalesToolkit.Translation.get('trackingSaveCart', 'trackingSaveCart'));
        $('#salestoolkit-cart-save-error').hide();
        $('#salestoolkit-cart-save-share-error').hide();
        let cart = SalesToolkit.Cart.getLoadedCart();
        if (!cart) {
            let defaultNamePrefix = SalesToolkit.Translation.get('saveCartDefaultPrefix', 'Saved Cart');
            $('#cartName').val(defaultNamePrefix + " " + (SalesToolkit.Cart.carts.length + 1));
            $('#cartSaveName').val(defaultNamePrefix + " " + (SalesToolkit.Cart.carts.length + 1));
        } else {
            $('#cartName').val(cart.name);
            $('#cartSaveName').val(cart.name);
        }
        $('#cartName').attr('maxlength', SalesToolkit.Theme.getIntegerProperty('maxLengthSavedCartsName', 45));
        $('#cartSaveName').attr('maxlength', SalesToolkit.Theme.getIntegerProperty('maxLengthSavedCartsName', 45));
        if (SalesToolkit.Theme.getBooleanProperty('shareAndSave', false)) {
            $('#basic').modal('show');
            _openShareModal('shareCart', undefined);
            return;
        }
        $('#saveCartModal').modal('show');
    }

    /**
     * Displays an error message in the cart save modal.
     * @param {string} message - The error message to display.
     */
    function _showCartSaveError(message) {
        if (!message || message === '') {
            $('#salestoolkit-cart-save-error').hide();
            $('#salestoolkit-cart-save-share-error').hide();
            return;
        }
        $('#cart-save-error-message').html(message);
        $('#cart-save-share-error-message').html(message);
        $('#salestoolkit-cart-save-error').show();
        $('#salestoolkit-cart-save-share-error').show();
    }

    /**
     * Attempts to save and then share the current cart.
     * @param {boolean} [overwrite=false] - Whether to overwrite an existing cart with the same name.
     * @param {object} [data] - Data object containing recipients and form data.
     * @param {string} [note] - A note for the share.
     * @param {boolean} [useShareLink=false] - Whether to generate a shareable link.
     */
    function _trySaveAndShareCart(overwrite = false, data = undefined, note = undefined, useShareLink = false) {
        let cartName = overwrite ? cartNameOverwrite : $('#cartSaveName').val();
        let currentCartName = SalesToolkit.Translation.get('currentCart', 'Current Cart');
        if (cartName === currentCartName || cartName === "Current Cart") {
            _showCartSaveError(SalesToolkit.Translation.getFormatted('saveCartErrorReservedName', "Cart name can't match {0}.", [currentCartName]));
            return;
        }
        let finished = function (success, message, requestOverwrite = false) {
            if (!success) {
                if (requestOverwrite) {
                    cartNameOverwrite = cartName;
                    overwriteData = data;
                    overwriteNote = note;
                    overwriteUseLink = useShareLink;
                    $('#saveCartModal').modal('hide');
                    $('#overwritePromptModal').modal('show');
                } else {
                    $('#saveCartModal').modal('show');
                    $('#overwritePromptModal').modal('hide');
                    _showCartSaveError(message);
                }
            } else if (success) {
                trackAppClick($('#saveCartModal'), '#saveCartModal', 'trackingSaveConfirm', SalesToolkit.Translation.get('trackingSaveConfirm', 'trackingSaveConfirm'));
                _showCartSaveError("");
                let notificationBody = (message === 'update')
                    ? SalesToolkit.Translation.get('cartUpdateSuccess', 'Cart updated successfully. It is now your currently loaded cart.')
                    : SalesToolkit.Translation.get('cartSaveSuccess', 'Cart saved successfully. It is now your currently loaded cart.');

                if (SalesToolkit.Theme.getBooleanProperty('updateContactsOnCartShare', false)) {
                    setTimeout(() => SalesToolkit.Contacts.update(), 1000);
                }
                try {
                    let loadedCart = SalesToolkit.Cart.getLoadedCart();
                    if (typeof loadedCart !== 'undefined') localStorage['currentSavedCart'] = loadedCart.id;
                } catch (err) { }

                if (message && message.hasOwnProperty('link') && SalesToolkit.Theme.getBooleanProperty('createLinkOnShareSavedCart', false)) {
                    _updateCartShareOptions();
                    let json = {};
                    json.link = message.link;
                    let whatsAppLink = 'https://web.whatsapp.com/send?text=';
                    if (supportsWhatsApp()) {
                        whatsAppLink = 'whatsapp://send?text=';
                    }
                    let shareLinkPopupEmailSubject = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailSubject', '');
                    $('#whatsapp-link').attr('href', whatsAppLink + encodeURI(json.link));
                    $('#downloadInput').val(json.link);
                    $('.qrCode img').attr('src', 'https://trustrack.atheneum.co/dms/public/barcode.png?type=QR_CODE&width=230&height=230&margin=0&content=' + encodeURI(json.link));
                    let shareLinkPopupEmailBody = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailBody', '{link}');
                    if (shareLinkPopupEmailBody.indexOf('{link}') != -1) {
                        shareLinkPopupEmailBody = shareLinkPopupEmailBody.replace('{link}', encodeURI(json.link));
                    }
                    $('#sms-link').attr('href', 'sms:?&body=' + shareLinkPopupEmailBody);
                    let email = data.recipients ? data.recipients.toString() : '';
                    if (shareLinkPopupEmailSubject === '')
                        $('#email-link').attr('href', 'mailto:' + email + '?body=' + shareLinkPopupEmailBody);
                    else
                        $('#email-link').attr('href', 'mailto:' + email + '?subject=' + shareLinkPopupEmailSubject + '&body=' + shareLinkPopupEmailBody);
                    if ($('#basic').css('display') == 'block') {
                        $('#basic').modal('hide');
                        setTimeout(function () {
                            $('#basic').modal('hide');
                        }, 0);
                    }
                    $('#shareLinkPopup').modal('show');
                }
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                $('#saveCartModal').modal('hide');
                $('#overwritePromptModal').modal('hide');
            }
        }
        SalesToolkit.Cart.saveCart(cartName, overwrite, data.recipients, note, finished, data.formData, useShareLink);
    }

    /**
     * Attempts to save the current cart.
     * @param {boolean} [overwrite=false] - Whether to overwrite an existing cart with the same name.
     */
    function _trySaveCart(overwrite = false) {
        let cartName = overwrite ? cartNameOverwrite : $('#cartName').val();
        let currentCartName = SalesToolkit.Translation.get('currentCart', 'Current Cart');
        if (cartName === currentCartName || cartName === "Current Cart") {
            _showCartSaveError(SalesToolkit.Translation.getFormatted('saveCartErrorReservedName', "Cart name can't match {0}.", [currentCartName]));
            return;
        }
        let loadedCart = SalesToolkit.Cart.getLoadedCart();
        if (loadedCart && cartName === loadedCart.name && (!SalesToolkit.User.permissions.canEditCarts && !_hasSimplifiedCartSavingPermission())) {
            $('#saveCartModal').modal('show');
            $('#overwritePromptModal').modal('hide');
            _showCartSaveError(SalesToolkit.Translation.get('errorCartEditNotAllowed', 'Cart names need to be unique, please update name and try again.'));
            return;
        }
        let finished = function (success, message, requestOverwrite = false) {
            if (!success) {
                if (requestOverwrite) {
                    cartNameOverwrite = cartName;
                    $('#saveCartModal').modal('hide');
                    $('#overwritePromptModal').modal('show');
                } else {
                    $('#saveCartModal').modal('show');
                    $('#overwritePromptModal').modal('hide');
                    _showCartSaveError(message);
                }
            } else if (success) {
                trackAppClick($('#saveCartModal'), '#saveCartModal', 'trackingSaveConfirm', SalesToolkit.Translation.get('trackingSaveConfirm', 'trackingSaveConfirm'));
                _showCartSaveError("");
                let notificationBody = (message === 'update')
                    ? SalesToolkit.Translation.get('cartUpdateSuccess', 'Cart updated successfully. It is now your currently loaded cart.')
                    : SalesToolkit.Translation.get('cartSaveSuccess', 'Cart saved successfully. It is now your currently loaded cart.');
                SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                $('#saveCartModal').modal('hide');
                $('#overwritePromptModal').modal('hide');
                try {
                    let loadedCart = SalesToolkit.Cart.getLoadedCart();
                    if (typeof loadedCart !== 'undefined') localStorage['currentSavedCart'] = loadedCart.id;
                } catch (err) { }
                if (SalesToolkit.Theme.getBooleanProperty('shareAfterSavingCart', false)) {
                    _shareSavedCart(SalesToolkit.Cart.loadedCartId);
                }
            }
        }
        SalesToolkit.Cart.saveCart(cartName, overwrite, undefined, undefined, finished);
    }

    /**
     * Updates the UI after a cart has been loaded.
     */
    function _cartLoaded() {
        let cartContents = SalesToolkit.Translation.get('cartContents', 'Cart Contents');
        if ((SalesToolkit.User.permissions.canViewCarts || _hasSimplifiedCartSavingPermission()) && SalesToolkit.Theme.getBooleanProperty('showLoadedCartNames', true)) {
            let cart = SalesToolkit.Cart.getLoadedCart();
            if (cart) {
                cartContents += " - " + cart.name;
            }
            let currentCartName = SalesToolkit.Translation.get('currentCart', 'Current Cart');
            if (cart && cart.name !== currentCartName && !cart.myCart) {
                $('body').toggleClass('sharedCart', true);
            } else if (cart && cart.name !== currentCartName && cart.myCart && (!SalesToolkit.User.permissions.canEditCarts && !_hasSimplifiedCartSavingPermission())) {
                $('body').toggleClass('sharedCart', true);
            } else {
                $('body').toggleClass('sharedCart', false);
            }
        }
        $('#cartContentsTitle').text(cartContents);
        _loadCartPanel();
    }

    /**
     * Calculates the maximum number of cart items to display based on panel height.
     * @returns {number} The maximum number of carts.
     */
    function _getMaxCartsPerHeight() {
        let aproxHeight = SalesToolkit.Theme.getIntegerProperty('aproxCartHeight', 85);
        let scrollHeight = ($('#atheneum-saved-carts-view').parent().parent().parent().height() - 103) - $('.saved-cart-wrapper.current').height();
        let maxCartsPerPage = Math.floor(scrollHeight / aproxHeight);
        return (maxCartsPerPage <= 0) ? SalesToolkit.Theme.getIntegerProperty('maxCartsPerPage', 12) : maxCartsPerPage;
    }

    /**
     * Renders the saved carts panel with pagination.
     */
    function _loadCartPanel() {
        $('#atheneum-saved-carts-view').children('.saved-cart-wrapper, #saved-carts-wrapper').remove();
        $('#atheneum-saved-carts-view').parent().parent().css('height', ($('#main-panel').height() - 12) + 'px');
        if (!SalesToolkit.User.permissions.canViewCarts && !_hasSimplifiedCartSavingPermission()) return;

        _addCartToPanel(SalesToolkit.Cart.currentCart);
        let maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPage', 12);
        if (screen.width < 768) {
            maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPageSmallScreen', 3);
        } else if (SalesToolkit.Theme.getBooleanProperty('tryApproximateMaxCartsToHeight', true)) {
            maxCartsPerPage = _getMaxCartsPerHeight();
        }

        $('#atheneum-saved-carts-view').append('<div id="saved-carts-wrapper"></div>');
        let index = (pageIndex > 0) ? maxCartsPerPage * pageIndex : 0;
        if (index >= SalesToolkit.Cart.carts.length) index = SalesToolkit.Cart.carts.length - 1;
        if (index < 0) index = 0;

        let maxPage = Math.ceil(SalesToolkit.Cart.carts.length / maxCartsPerPage);
        $('#saved-carts-paging').find('.current').html((pageIndex + 1) + "/" + maxPage);

        let maxIndex = index + maxCartsPerPage;
        if (maxIndex > SalesToolkit.Cart.carts.length) maxIndex = SalesToolkit.Cart.carts.length;

        let cartArr = [...SalesToolkit.Cart.carts].sort((a, b) => b.created - a.created);
        for (let i = index; i < maxIndex; i++) {
            _addCartToPanel(cartArr[i]);
        }

        applyThemeToImage('saveCartIconsDelete', '.deleteSaveCart img', 'img/default/SavedCartDelete.svg');
        applyThemeToImage('saveCartIconsShare', '.shareSaveCart img', 'img/default/SavedCartShare.svg');

        let smallScreenCartPanels = screen.width < 768 && SalesToolkit.Theme.getBooleanProperty('showCartsPanelSmall', true) && (SalesToolkit.User.permissions.canViewCarts || _hasSimplifiedCartSavingPermission());
        if (smallScreenCartPanels) {
            resizeCartPanelsHeight();
            let flexDirection = SalesToolkit.Theme.getBooleanProperty('savedCartPanelsSmallScreenAtTop', true) ? 'column-reverse' : 'column';
            $('.row:has(#saved-carts-panel)').css('flex-direction', flexDirection);
        }

        const activeElement = document.querySelector('#saved-carts-wrapper > .active');
        if (activeElement) {
            $('#saved-carts-wrapper').scrollTop(activeElement.offsetTop);
        }
    }

    /**
     * Loads a specific saved cart.
     * @param {string} cartId - The ID of the cart to load.
     */
    function _loadCart(cartId) {
        SalesToolkit.Cart.loadCart(cartId);
        if (typeof cartId === 'undefined' || cartId === 'undefined') {
            if (!SalesToolkit.Theme.getBooleanProperty('alwaysKeepLastSavedCart', true))
                localStorage.removeItem('currentSavedCart');
        } else {
            localStorage['currentSavedCart'] = cartId;
        }
    }

    /**
     * Adds a single cart's UI to the saved carts panel.
     * @param {object} cart - The cart object to render.
     */
    function _addCartToPanel(cart) {
        if (typeof htmlToElement !== 'function')
            throw new Error("DEFINE htmlToElement");

        let currentCartName = SalesToolkit.Translation.get('currentCart', 'Current Cart');
        let wrapperClass = "mine";
        if (cart.name === currentCartName) {
            wrapperClass = "current"
        }
        let loadedCart = SalesToolkit.Cart.getLoadedCart();
        if (!cart.myCart && cart.name !== currentCartName) {
            wrapperClass = "shared";
        }
        if ((loadedCart === undefined && cart.name === currentCartName) || cart.id === loadedCart?.id) {
            wrapperClass += " active";
        }
        let panel = document.getElementById('atheneum-saved-carts-view');
        if (wrapperClass.indexOf('current') < 0) {
            panel = document.getElementById('saved-carts-wrapper');
        }
        let wrapper = htmlToElement("<div onclick='window.loadCart(\"" + cart.id + "\")' class='saved-cart-wrapper " + wrapperClass + "' data-cart-name='" + cart.name + "'></div>");
        let metaWrapper = htmlToElement("<div class='meta-wrapper'></div>");
        let textWrapper = htmlToElement("<div class='text-wrapper'></div>");
        let cartName = htmlToElement("<span class='cartName'>" + cart.name + "</span>");
        wrapper.appendChild(cartName);
        let infoWrapper = htmlToElement("<div class='info-wrapper'></div>");
        if (cart.name !== currentCartName && cart.myCart) {
            if (SalesToolkit.Theme.getBooleanProperty('showSavedCartCreatedDate', true)) {
                let createdDate = htmlToElement("<div class='info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartCreatedDate', 'Created: ') + "</span><span class='info'>" + (new Date(cart.created).toLocaleString()) + "</span></div>");
                wrapper.appendChild(createdDate);
            }
            if (SalesToolkit.Theme.getBooleanProperty('showSavedCartModifiedDate', false)) {
                let modifiedDate = htmlToElement("<div class='info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartModifiedDate', 'Modified: ') + "</span><span class='info'>" + (new Date(cart.modified).toLocaleString()) + "</span></div>");
                wrapper.appendChild(modifiedDate);
            }
        }
        let documentCount = htmlToElement("<div class='info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartNoAssets', 'No. of Assets: ') + "</span><span class='info'>" + SalesToolkit.Cart.getCartAssetIds(cart).length + "</span></div>");
        infoWrapper.appendChild(documentCount);
        if (!cart.myCart && cart.name !== currentCartName) {
            let sharedBy = htmlToElement("<div class='email info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartSharedBy', 'Shared by: ') + "</span><span class='info'>" + (cart.sharedBy?.email || SalesToolkit.Translation.get('unknown', 'Unknown')) + "</span></div>");
            infoWrapper.appendChild(sharedBy);
            if (SalesToolkit.Theme.getBooleanProperty('showSharedDateOnCarts', true)) {
                let sharedDate = htmlToElement("<div class='date info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartSharedDate', 'Shared on: ') + "</span><span class='info'>" + (new Date(cart.sharedDate).toLocaleString()) + "</span></div>");
                infoWrapper.appendChild(sharedDate);
            }
        }
        if (cart.name !== currentCartName && (cart.hasOwnProperty('registerInterest') || cart.hasOwnProperty('mlr') || cart.hasOwnProperty('shares'))) {
            let historyIcons = "<span class='history-icons info'>";
            if (cart.hasOwnProperty('registerInterest')) {
                historyIcons += "<div class='registerInterestHistory' onclick='window.showSavedCartUsageHistory(\"" + cart.id + "\", \"registerInterest\")'>" + SalesToolkit.Translation.get('registeredInterest', 'Registered Interest') + "</div>";
            }
            if (cart.hasOwnProperty('mlr')) {
                historyIcons += "<div class='mlrHistory' onclick='window.showSavedCartUsageHistory(\"" + cart.id + "\", \"mlr\")'>" + SalesToolkit.Translation.get('mlr', 'MLR') + "</div>";
            }
            if (cart.hasOwnProperty('shares')) {
                historyIcons += "<div class='sharesHistory' onclick='window.showSavedCartUsageHistory(\"" + cart.id + "\", \"shares\")'>" + SalesToolkit.Translation.get('shares', 'Shares') + "</div>";
            }
            historyIcons += "</span>";
            let registerInterest = htmlToElement("<div class='info-group'><span class='info-label'>" + SalesToolkit.Translation.get('savedCartUsedIn', '') + "</span>" + historyIcons + "</div>");
            infoWrapper.appendChild(registerInterest);
        }
        let shareClass = "";
        if (!SalesToolkit.User.permissions.canShareCarts) {
            shareClass = "noShare";
        }
        let buttonWrapper = htmlToElement("<div class='button-wrapper'></div>");
        let deleteButton = htmlToElement("<div class='deleteSaveCart' onclick='window.deleteCart(\"" + cart.id + "\")'><img src='' /></div>");
        let shareButton = htmlToElement("<div class='shareSaveCart " + shareClass + "'  onclick='window.shareSavedCart(\"" + cart.id + "\")'><img src='' /></div>");
        buttonWrapper.appendChild(shareButton);
        if (!cart.myCart && cart.name !== currentCartName && (SalesToolkit.User.permissions.canUnshareCarts || hasSimplifiedCartSharingPermission())) {
            buttonWrapper.appendChild(deleteButton);
        } else if (cart.name !== currentCartName && cart.myCart && (SalesToolkit.User.permissions.canDeleteCarts || _hasSimplifiedCartSavingPermission())) {
            buttonWrapper.appendChild(deleteButton);
        }
        textWrapper.appendChild(infoWrapper);
        metaWrapper.appendChild(textWrapper);
        metaWrapper.appendChild(buttonWrapper);
        wrapper.appendChild(metaWrapper);
        panel.appendChild(wrapper);
    }

    function _showSavedCartUsageHistory(cartId, type) {
        // Placeholder for future implementation
    }

    /**
     * Initiates the cart deletion process.
     * @param {string} cartId - The ID of the cart to delete.
     */
    function _deleteCart(cartId) {
        cartToDelete = cartId;
        $('#deletePromptModal').modal('show');
    }

    /**
     * Confirms and executes the cart deletion.
     */
    function _confirmDeleteCart() {
        if (!cartToDelete) return;
        let cartId = cartToDelete;
        cartToDelete = null;
        SalesToolkit.Cart.deleteCart(cartId, function (success, message) {
            if (success) {
                $('#deletePromptModal').modal('hide');
                if (SalesToolkit.Theme.getBooleanProperty('showCartDeletedSuccessNotification', true)) {
                    let notificationBody = SalesToolkit.Translation.get('cartDeletedSuccess', 'Cart deleted');
                    SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                }
            } else {
                SalesToolkit.UI.Notifications.showCustomNotification("cart", message);
            }
        });
    }

    /**
     * Cancels the cart deletion process.
     */
    function _cancelDeleteCart() {
        cartToDelete = null;
    }

    /**
     * Initiates the process to share a saved cart.
     * @param {string} cartId - The ID of the cart to share.
     */
    function _shareSavedCart(cartId) {
        trackAppClick($(this), '.shareSaveCart', 'trackingShareSavedCart', SalesToolkit.Translation.get('trackingShareSavedCart', 'trackingShareSavedCart'));
        $('#basic').modal('show');
        _openShareModal('shareCart', undefined, cartId);
    }

    /**
     * Cancels the cart overwrite process.
     */
    function _cancelOverwriteCart() {
        cartNameOverwrite = null;
        overwriteData = null;
        overwriteNote = null;
    }

    /**
     * Confirms and executes the cart overwrite process.
     */
    function _confirmOverwriteCart() {
        let cartToDelete = SalesToolkit.Cart.getMyCartByName(cartNameOverwrite);
        SalesToolkit.Cart.deleteCart(cartToDelete.id, (success, message) => {
            if (success) {
                if (SalesToolkit.Theme.getBooleanProperty('shareAndSave', false)) {
                    _trySaveAndShareCart(true, overwriteData, overwriteNote, overwriteUseLink);
                } else {
                    _trySaveCart(true);
                }
            }
        });
    }

    function _updateItemCartAndFavouritesTagsAndReturnFalse() {
        return false;
    }

    /**
     * Sets the height of a textarea to fit its content.
     * @param {string} fieldId - The ID of the textarea element.
     */
    function _setHeight(fieldId) {
        const element = document.getElementById(fieldId);
        if (element) {
            element.style.height = 'auto';
            element.style.height = element.scrollHeight + 'px';
        }
    }

    function _initSavedCarts() {
        if (typeof htmlToElement !== 'function')
            throw new Error("DEFINE htmlToElement");

        $('#saved-carts-panel').activity(true).css("pointer-events", "none");
        SalesToolkit.Cart.getCarts(function (success, message) {
            $('#saved-carts-panel').activity(false).css("pointer-events", "all");
            if (!success) {
                SalesToolkit.UI.Notifications.showCustomNotification("cart", message);
            }
            let loadCartId = SalesToolkit.Pages.CurrentPage.getQueryParam("loadCart");
            if (loadCartId) {
                SalesToolkit.Cart.loadCart(loadCartId);
            } else {
                _cartLoaded();
            }
        });

        pageControls = htmlToElement("<div class='pageControls'></div>");
        let firstPage = htmlToElement("<div class='first' style='font-weight:bold; color:#FF3300;'>" + SalesToolkit.Translation.get("firstPage", "&laquo;") + "</div>");
        let previousPage = htmlToElement("<div class='previous' style='font-weight:bold; color:#FF3300;'>" + SalesToolkit.Translation.get("previousPage", "&lsaquo;") + "</div>");
        let currentPage = htmlToElement("<div class='current' style='font-size:1.5rem; line-height:3rem;'>1</div>");
        let nextPage = htmlToElement("<div class='next' style='font-weight:bold; color:#FF3300;'>" + SalesToolkit.Translation.get("nextPage", "&rsaquo;") + "</div>");
        let lastPage = htmlToElement("<div class='last' style='font-weight:bold; color:#FF3300;'>" + SalesToolkit.Translation.get("lastPage", "&raquo;") + "</div>");

        $(firstPage).on('click', function () {
            pageIndex = 0;
            _loadCartPanel();
        });
        $(lastPage).on('click', function () {
            let maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPage', 12);
            if (screen.width < 768) {
                maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPageSmallScreen', 3);
            } else if (SalesToolkit.Theme.getBooleanProperty('tryApproximateMaxCartsToHeight', true)) {
                maxCartsPerPage = _getMaxCartsPerHeight();
            }
            pageIndex = (SalesToolkit.Cart.carts.length == 0) ? 0 : Math.ceil(SalesToolkit.Cart.carts.length / maxCartsPerPage) - 1;
            _loadCartPanel();
        });
        $(previousPage).on('click', function () {
            pageIndex -= 1;
            if (pageIndex < 0) pageIndex = 0;
            _loadCartPanel();
        });
        $(currentPage).on('click', function () {
            // Future page selector logic
            _loadCartPanel();
        });
        $(nextPage).on('click', function () {
            let maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPage', 12);
            if (screen.width < 768) {
                maxCartsPerPage = SalesToolkit.Theme.getIntegerProperty('maxCartsPerPageSmallScreen', 3);
            } else if (SalesToolkit.Theme.getBooleanProperty('tryApproximateMaxCartsToHeight', true)) {
                maxCartsPerPage = _getMaxCartsPerHeight();
            }
            if (SalesToolkit.Cart.carts.length > 0) {
                let maxPage = Math.ceil(SalesToolkit.Cart.carts.length / maxCartsPerPage);
                pageIndex += 1;
                if (pageIndex >= maxPage) pageIndex = maxPage - 1;
            } else {
                pageIndex = 0;
            }
            _loadCartPanel();
        });

        pageControls.appendChild(firstPage);
        pageControls.appendChild(previousPage);
        pageControls.appendChild(currentPage);
        pageControls.appendChild(nextPage);
        pageControls.appendChild(lastPage);
        $('#saved-carts-paging').append(pageControls);
    }
    //#endregion

    function _destroy() {
        console.log("Cart module destroyed.");
        // Remove event listeners
        // document.getElementById('search-button').removeEventListener('click', this.handleSearch);
        // Clean up any other DOM manipulations
        delete window.filterContactModalFilter; // Remove global function on cleanup
        $('#basic').off('click', handleBasicClick);
        $('#shareLinkPopup').off('click', handleShareLinkPopupClick);
        $("a.fullscreen").off('click', _handleFullscreenClick);
        $('#salestoolkit-email-addresses-div').off('keyup paste click');
        $('#cartModal .btn-primary').off('click', _handleEmptyCartConfirm);
        $('#salestoolkit-do-share').off('click');
        $('#salestoolkit-sharelink').off('click');
        
        $('#salestoolkit-save-cart').off('click');
        $('#saveCartModal .btn-primary').off('click');
        $('#overwritePromptModal .btn-primary').off('click');
        $('#overwritePromptModal .btn-default').off('click');
        $('#deletePromptModal .btn-primary').off('click');
        $('#deletePromptModal .btn-default').off('click');
        if (pageControls) {
            $(pageControls).find('.first, .last, .previous, .current, .next').off('click');
        }

         clearTimeout(mainTimeoutId);
            clearInterval(countdownIntervalId);
            clearInterval(pollingIntervalId);
            clearTimeout(countdownStarterId);
         activityEvents.forEach(eventType => {
                window.removeEventListener(eventType, _handleUserActivity);
            });


        // Remove global functions on cleanup
        delete window.loadCart;
        delete window.deleteCart;
        delete window.shareSavedCart;
        delete window.showSavedCartUsageHistory;
        delete window.globalLookupCallback;
        delete window.atheneumGL;
        delete window.updateItemCartAndFavouritesTagsAndReturnFalse;
        delete window.openedCartModal;
        $('#salestoolkit-share-cart').off("click");
        $('#salestoolkit-registerInterest-cart').off("click");
        $('#salestoolkit-mlr-cart').off("click");
        $('#salestoolkit-form-fields-div').off('blur', 'input');
        $('body').toggleClass('showingSavedCarts', false);
        // --- DETACH WINDOW RESIZE LISTENER ---
        $(window).off('resize', setupColumns);

        // Restore the original global goBack function
        if (typeof _originalGoBack === 'function') {
            window.goBack = _originalGoBack;
        } else {
            // If there was no original goBack, remove the global reference
            delete window.goBack;
        }

        if (salestoolkitUICartInstance) {
            // Call the destroy method on the salestoolkitUICart instance if it exists
            if (typeof salestoolkitUICartInstance.destroy === 'function') {
                salestoolkitUICartInstance.destroy();
            } else {
                console.warn("salestoolkitUICart instance does not have a destroy method.");
            }

            // Remove the global reference
            delete window.salestoolkitUICart;
            salestoolkitUICartInstance = null;
        }

        _stopCamera();
        $('#salestoolkit-camera').off('click', _openedCameraModal);
        $('#take-scan-button').off('click');
        $('#cameraModal').off('hidden.bs.modal', _stopCamera);

        // Restore original onresize handler
        if (typeof _originalOnResize === 'function') {
            window.onresize = _originalOnResize;
            _originalOnResize = null;
        } else {
            window.onresize = null;
        }
    };

    async function _init() {
        if (typeof SalesToolkit === 'undefined') {
            throw new Error("cartModule: SalesToolkit is not defined. Cannot initialize.");
        }

        if (typeof SalesToolkit.Theme === 'undefined') {
            throw new Error("cartModule: SalesToolkit.Theme is not defined. Cannot initialize.");
        }
        console.log("Cart module initialized.");

        window.filterContactModalFilter = _filterContactModalFilter; // Make function global for onclick handlers
        $('#basic').on('click', handleBasicClick);
        $('#shareLinkPopup').on('click', handleShareLinkPopupClick);
        $("a.fullscreen").on('click', _handleFullscreenClick);
        $('#cartModal .btn-primary').on('click', _handleEmptyCartConfirm);

        $('#salestoolkit-do-share').on('click', _handleDoShareClick);
        $('#salestoolkit-sharelink').on('click', _handleShareLinkClick);
        
        $('#salestoolkit-save-cart').on('click', _openCartSaveModal);
        $('#saveCartModal .btn-primary').on('click', () => _trySaveCart(false));
        $('#overwritePromptModal .btn-primary').on('click', _confirmOverwriteCart);
        $('#overwritePromptModal .btn-default').on('click', _cancelOverwriteCart);
        $('#deletePromptModal .btn-primary').on('click', _confirmDeleteCart);
        $('#deletePromptModal .btn-default').on('click', _cancelDeleteCart);

        $('#salestoolkit-email-addresses-div')
            .on('keyup', '.cart-email-input', function () { _emailInputChanged(this); })
            .on('paste', '.cart-email-input', function () { setTimeout(() => _emailInputChanged(this), 5); })
            .on('click', '.cart-remove-email', function () { _salestoolkitShareFormRemoveEmailAddressAfter(this); })
            .on('click', '.cart-add-email', function () { _salestoolkitShareFormAddEmailAddressAfter(this); });

        $('#salestoolkit-share-cart').on("click", function (event) {
            trackAppClick($('#salestoolkit-share-cart'), '#salestoolkit-share-cart', 'trackingCartSend', SalesToolkit.Translation.get('trackingCartSend', 'trackingCartSend'));

            //TODO DO new API call if veeva id is available - API not made yet
            if (SalesToolkit.User.veevaUser == true) {
                trackAppClick($('#salestoolkit-share-cart'), '#salestoolkit-share-cart', 'trackingCartVeevaSend', SalesToolkit.Translation.get('trackingCartVeevaSend', 'trackingCartVeevaSend'), SalesToolkit.Cart.assetIds);
                window.parent.postMessage({
                    "event": "VEEVA_CART_CHECKOUT",
                    "assetIds": SalesToolkit.Cart.assetIds
                }, "*");
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();
                SalesToolkit.Cart.empty(function (success, message) {
                    salestoolkitUICart.removeAllItems();
                    SalesToolkit.UI.Cart.updateMenuCartBadge();
                    trackAppClick($('#cartModal .btn-primary'), '#cartModal .btn-primary', 'trackingCartClear', SalesToolkit.Translation.get('trackingCartClear', 'trackingCartClear'));
                    _disableButtonsIfCartEmpty();
                    _loadCartPanel();
                    _cartModuleGoBack();
                });
                return false;
            }
            _openShareModal('share', event);
        });

        $('#salestoolkit-registerInterest-cart').on("click", function (event) {
            trackAppClick($('#salestoolkit-registerInterest-cart'), '#salestoolkit-registerInterest-cart', 'trackingCartRegisterInterest', SalesToolkit.Translation.get('trackingCartRegisterInterest', 'trackingCartRegisterInterest'));
            _openShareModal('registerInterest', event);
        });

        $('#salestoolkit-mlr-cart').on("click", function (event) {
            trackAppClick($('#salestoolkit-mlr-cart'), '#salestoolkit-mlr-cart', 'trackingCartMLR', SalesToolkit.Translation.get('trackingCartMLR', 'trackingCartMLR'));
            _openShareModal('mlr', event);
        });

        $('#salestoolkit-form-fields-div').on('blur', 'input', async function (e) {
            if (!SalesToolkit.Theme.getBooleanProperty('useContactFilterModal', true)) {
                return;
            }

            let fieldName = $(this).attr('name');
            let fieldsToReactTo = SalesToolkit.Theme.getStringProperty('contactFilterModalManualFields', 'firstName,lastName').split(',');

            if (fieldsToReactTo.indexOf(fieldName) < 0) {
                return;
            }

            let emailField = $('#salestoolkit-form-fields-div').find("input[data-type='EMAIL']").eq(0);
            if (emailField.length == 0 || emailField.val().length > 0) {
                emailField = $('#salestoolkit-email-addresses-div').find("input[data-type='EMAIL']").eq(0);
                if (emailField.length == 0 || emailField.val().length > 0)
                    return;
            }

            if (SalesToolkit.Contacts.__preferLiveQueryToCache) {
                let fieldValue = $(this).val();

                //TODO need api to do this but using several fields in a query with availability for ands and ors 
                await SalesToolkit.Contacts.getByFieldValueAsync(fieldName, fieldValue, true, SalesToolkit.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100), {
                    success: function (contacts) {
                        _showGlobalLookupFromFieldBlur(contacts, fieldsToReactTo);
                    },
                    failure: function (reason, httpStatus, errorCode) {
                        let errorCodeHex;
                        if (typeof errorCode == 'number') {
                            errorCodeHex = errorCode.toString(16);
                            while (errorCodeHex.length < 8) {
                                errorCodeHex = '0' + errorCodeHex;
                            }
                        }

                        let notificationBody = SalesToolkit.Translation.get('notificationLiveContactSearchError', 'Error: Could not search contacts: ' + errorCodeHex);
                        SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    },
                    offline: function () {
                        let notificationBody = SalesToolkit.Translation.get('notificationLiveContactSearchOffline', 'Error: Could not search contacts while offline');
                        SalesToolkit.UI.Notifications.showCustomNotification("cart", notificationBody);
                    }
                });
            } else {
                try {
                    if (e.relatedTarget.classList.contains('suggestion')) {
                        return false;
                    }
                } catch (err) {

                }

                await window.atheneumGL.shouldPerformLookupForField($(this));
            }
        });
        // --- RUN PANEL SETUP ---
        setupColumns();

        // --- ATTACH WINDOW RESIZE LISTENER ---
        $(window).on('resize', setupColumns);

        _setupCartFeaturesAndModals();

        // Call the private function to disable/enable buttons based on cart content
        _disableButtonsIfCartEmpty();

        // Store the original global goBack function, if it exists
        if (typeof window.goBack === 'function') {
            _originalGoBack = window.goBack;
        } else {
            _originalGoBack = undefined; // Explicitly set to undefined if it didn't exist
        }

        // Assign the cart module's goBack logic to the global window.goBack
        window.goBack = _cartModuleGoBack;

        // Call SalesToolkit.Forms.update
        SalesToolkit.Forms.update({
            success: function () {
                // Success callback logic for Forms update
            }
        });

        // Call SalesToolkit.Library.update
        SalesToolkit.Library.update({
            success: function () {
                if (typeof salestoolkitUICart !== 'undefined' && typeof salestoolkitUICart.refresh === 'function') {
                    salestoolkitUICart.refresh();
                } else {
                    console.warn("salestoolkitUICart.refresh not found, skipping UI cart refresh.");
                }
            },
            failure: function (...args) { // Using rest parameters for generic callback
                if (typeof Atheneum !== 'undefined' && Atheneum.Callbacks && typeof Atheneum.Callbacks.logFailureDetails === 'function') {
                    Atheneum.Callbacks.logFailureDetails(...args);
                } else {
                    console.warn("Atheneum.Callbacks.logFailureDetails not found, logging failure details directly:", args);
                }
            }
        });

        // Initialize salestoolkitUICart and make it globally accessible
        const cartPortletElement = document.getElementById('salestoolkit-cart-portlet');
        if (cartPortletElement) {
            salestoolkitUICartInstance = SalesToolkit.UI.Cart(cartPortletElement);
            window.salestoolkitUICart = salestoolkitUICartInstance; // Make it globally accessible
            console.log("salestoolkitUICart initialized and made global.");

            // Attach event listeners
            salestoolkitUICartInstance.on('info-requested', _onInfoRequested);
            salestoolkitUICartInstance.on('item-added', _onItemAdded);
            salestoolkitUICartInstance.on('refresh', _onRefresh);
            salestoolkitUICartInstance.on('item-removed-from-cart', _onItemRemovedFromCart);
            salestoolkitUICartInstance.on("item-update-fav-button", _onItemUpdateFavButton);
            salestoolkitUICartInstance.on("item-added", _onItemAddedTriggerFavButton); // Note: Original code had 'item-added' twice with different handlers. This one triggers fav button update.
            salestoolkitUICartInstance.on("item-action-view-click", _onItemActionViewClick);
            salestoolkitUICartInstance.on("item-action-failure", _onItemActionFailure);
            salestoolkitUICartInstance.on("item-action-click", _onItemActionClick);
            salestoolkitUICartInstance.on("item-added-to-favourites", _onItemAddedToFavourites);
            salestoolkitUICartInstance.on("item-removed-from-favourites", _onItemRemovedFromFavourites);
            salestoolkitUICartInstance.on('item-removed', _onCartItemChange);
            salestoolkitUICartInstance.on('item-added', _onCartItemChange);
            // Initial refresh after a delay
            setTimeout(function () {
                if (salestoolkitUICartInstance) {
                    salestoolkitUICartInstance.refresh();
                }
            }, 500);

        } else {
            console.error("Element with ID 'salestoolkit-cart-portlet' not found for SalesToolkit.UI.Cart initialization.");
        }

        hasSomeSharing = SalesToolkit.User.permissions.canRegisterInterest || SalesToolkit.User.permissions.canMLR || SalesToolkit.User.permissions.canShare;

        if (typeof SalesToolkit.Forms.userDetails !== 'object' && SalesToolkit.Theme.getBooleanProperty('showCartCameraIcon', false) && hasSomeSharing) {
            $('#salestoolkit-camera').show();
        } else {
            $('#salestoolkit-camera').hide();
        }

        if (typeof CardReader !== 'undefined' && typeof Html5Qrcode !== 'undefined') {
            cardReader = new CardReader(document.getElementById('cameraFeedVideo'));
            html5QrCode = new Html5Qrcode("barqrcode");
            $('#salestoolkit-camera').on('click', _openedCameraModal);
            // Assuming a button with this ID exists for manual scans
            $('#take-scan-button').on('click', () => _takeScan(false));
            $('#cameraModal').on('hidden.bs.modal', _stopCamera);
        } else {
            console.error("CardReader or Html5Qrcode is not defined. Camera functionality will be disabled.");
            $('#salestoolkit-camera').hide();
        }

        if (typeof window.onresize === 'function') {
            _originalOnResize = window.onresize;
        }
        window.onresize = _resizeHandler;

        SalesToolkit.Favourites.update();
        SalesToolkit.NewsFeed.checkForReplies();

        // Make functions global for onclick handlers
        window.loadCart = _loadCart;
        window.deleteCart = _deleteCart;
        window.shareSavedCart = _shareSavedCart;
        window.showSavedCartUsageHistory = _showSavedCartUsageHistory;
        window.globalLookupCallback = _globalLookupCallback;
        window.updateItemCartAndFavouritesTagsAndReturnFalse = _updateItemCartAndFavouritesTagsAndReturnFalse;
        window.openedCartModal = _openedCartModal;
        _initSavedCarts();

    }

    return {
        init: _init,
        destroy: _destroy,
        checkRemoteCompletionEnd : _checkRemoteCompletionEnd,
        templateHTML: _templateHTML,
       
    }
})();
